(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["complementary-products"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
          setupCardSwiping();
          setupSlider();
          setupScrollTrack();
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  function setupCardSwiping() {
    const swipeTracks = document.querySelectorAll('#complementaryProducts .card-product--image-swipe-track');
    swipeTracks.forEach((swipeTrack) => {
      const leftArrow = swipeTrack.closest('.card-product--image-swipe-container').querySelector('.pcpa-left');
      const rightArrow = swipeTrack.closest('.card-product--image-swipe-container').querySelector('.pcpa-right');
      const paginationBullets = swipeTrack
        .closest('.card-product--image-swipe-container')
        .querySelectorAll('.product-card--pagination-bullet');

      const updateArrowState = () => {
        const maxScrollLeft = swipeTrack.scrollWidth - swipeTrack.clientWidth;
        if (swipeTrack.scrollLeft <= 0) {
          leftArrow.classList.add('faded');
        } else {
          leftArrow.classList.remove('faded');
        }

        if (swipeTrack.scrollLeft >= maxScrollLeft - 2) {
          rightArrow.classList.add('faded');
        } else {
          rightArrow.classList.remove('faded');
        }
      };

      const updatePagination = () => {
        const scrollLeft = swipeTrack.scrollLeft;
        const slideWidth = swipeTrack.querySelector('.card-product--image-slide')?.clientWidth || 1;
        const activeIndex = Math.round(scrollLeft / slideWidth) + 1;

        paginationBullets.forEach((bullet) => {
          if (parseInt(bullet.dataset.value, 10) === activeIndex) {
            bullet.classList.add('active');
          } else {
            bullet.classList.remove('active');
          }
        });
      };

      const onScroll = () => {
        updateArrowState();
        updatePagination();
      };

      swipeTrack.addEventListener('scroll', onScroll);

      leftArrow.addEventListener('click', () => {
        event.preventDefault(); // Prevent the link's default behavior
        const slideWidth = swipeTrack.querySelector('.card-product--image-slide')?.clientWidth || 1;
        swipeTrack.scrollBy({
          left: -slideWidth,
          behavior: 'smooth',
        });
      });

      rightArrow.addEventListener('click', () => {
        event.preventDefault(); // Prevent the link's default behavior
        const slideWidth = swipeTrack.querySelector('.card-product--image-slide')?.clientWidth || 1;
        swipeTrack.scrollBy({
          left: slideWidth,
          behavior: 'smooth',
        });
      });

      // Initialize states
      updateArrowState();
      updatePagination();
    });
  }

  function setupSlider() {
    const sliderWrapper = document.querySelector('#complementaryProducts .comp-products-grid-wrapper');
    const sliderContainer = document.querySelector('#complementaryProducts .comp-products-grid');
    const leftArrow = document.querySelector('#complementaryProducts .slider-arrow-left');
    const rightArrow = document.querySelector('#complementaryProducts .slider-arrow-right');

    if (!sliderContainer || !leftArrow || !rightArrow) return;

    const setArrowState = () => {
      const scrollPosition = sliderContainer.scrollLeft;
      const containerWidth = sliderContainer.clientWidth;
      const totalWidth = sliderContainer.scrollWidth;
      const scrollLimit = totalWidth - containerWidth;

      // Find the first image element within the slider-grid
      const firstImage = sliderContainer.querySelector('img');
      
      // Get the height of the first image
      const imageHeight = firstImage ? firstImage.clientHeight : 0;

      // Apply top margin to arrows based on half of the image height
      if (sliderWrapper.classList.contains('slider-arrows-position-middle') && leftArrow && rightArrow && imageHeight !== 0) {
        const marginTop = (imageHeight * 0.5) - 24;
        leftArrow.style.marginTop = marginTop + 'px';
        rightArrow.style.marginTop = marginTop + 'px';
      }      
      
      if (scrollPosition <= 0) {
        leftArrow.classList.add('disabled');
      } else {
        leftArrow.classList.remove('disabled');
      }

      if (scrollPosition >= scrollLimit - 2) {
        rightArrow.classList.add('disabled');
      } else {
        rightArrow.classList.remove('disabled');
      }
    };

    setArrowState();

    sliderContainer.addEventListener('scroll', setArrowState);
    window.addEventListener('resize', setArrowState);

    function scrollToSnap(direction) {
      const items = sliderContainer.querySelectorAll('.grid__item');
      if (!items.length) return;

      const currentScroll = sliderContainer.scrollLeft;

      let closestIndex = 0;
      let closestDistance = Infinity;

      items.forEach((item, index) => {
        const distance = Math.abs(item.offsetLeft - currentScroll);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      const targetIndex = Math.max(
        0,
        Math.min(items.length - 1, closestIndex + direction)
      );

      sliderContainer.scrollTo({
        left: items[targetIndex].offsetLeft,
        behavior: 'smooth',
      });
    }

    leftArrow.addEventListener('click', () => scrollToSnap(-1));
    rightArrow.addEventListener('click', () => scrollToSnap(1));
  }

  // Slider custom scrollbar

  function setupScrollTrack() {
    const wrapper = document.querySelector('#complementaryProducts .comp-products-grid-wrapper');
    if (wrapper) {
      const slider = wrapper.querySelector('#complementaryProducts .comp-products-grid');
      const track = wrapper.querySelector('.slider-custom-scrollbar-track');
      const marker = wrapper.querySelector('.slider-custom-scrollbar-marker');
    
      if (slider && track && marker) {
        function updateMarkerWidthAndVisibility() {
          const visibleWidth = slider.clientWidth;
          const scrollableWidth = slider.scrollWidth;
    
          if (scrollableWidth <= visibleWidth) {
            track.classList.add('hidden');
          } else {
            track.classList.remove('hidden');
            const trackWidth = track.clientWidth;
            const markerWidth = (visibleWidth / scrollableWidth) * trackWidth;
            marker.style.width = `${markerWidth}px`;
          }
        }
    
        function updateMarkerPosition() {
          const scrollLeft = slider.scrollLeft;
          const scrollableWidth = slider.scrollWidth - slider.clientWidth;
          const trackWidth = track.clientWidth - marker.clientWidth;
    
          const left = (scrollableWidth > 0) ? (scrollLeft / scrollableWidth) * trackWidth : 0;
          marker.style.transform = `translateX(${left}px)`;
        }
    
        // Initial setup
        updateMarkerWidthAndVisibility();
        updateMarkerPosition();
    
        // On scroll
        slider.addEventListener('scroll', updateMarkerPosition);
    
        // On window resize
        window.addEventListener('resize', () => {
          updateMarkerWidthAndVisibility();
          updateMarkerPosition();
        });
      }
    }
  }
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fsk-behandlungen"] && !Shopify.designMode) return;
  try {
    
(() => {
 if (customElements.get('fsk-treatment-guide')) return;
 customElements.define('fsk-treatment-guide', class extends HTMLElement {
  connectedCallback() {
   if (this.controller) return;
   this.controller = new AbortController();
   const signal = this.controller.signal;
   const start = () => {
    if (this.ready || !this.isConnected) return;
    this.ready = true;
    const filters = this.querySelector('.fsk-filters');
    const buttons = [...this.querySelectorAll('[data-fsk-filter]')];
    const cards = [...this.querySelectorAll('[data-fsk-category]')];
    const status = this.querySelector('[role="status"]');
    const allowed = buttons.map(button => button.dataset.fskFilter);
    this.animations = new Map();
    this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const cancelFor = element => {
     this.animations.get(element)?.cancel();
     this.animations.delete(element);
    };
    const apply = value => {
     const chosen = allowed.includes(value) ? value : 'alle';
     buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.fskFilter === chosen)));
     let count = 0;
     cards.forEach(card => {
      card.hidden = chosen !== 'alle' && card.dataset.fskCategory !== chosen;
      if (card.hidden) cancelFor(card); else count++;
     });
     if (status) status.textContent = count + (count === 1 ? ' Behandlung' : ' Behandlungen');
    };
    if (filters && status && buttons.length && cards.length) {
     apply(new URLSearchParams(location.search).get('bereich'));
     filters.hidden = false;
     buttons.forEach(button => button.addEventListener('click', () => apply(button.dataset.fskFilter), {signal}));
    }
    const cancelMotion = () => {
     this.revealObserver?.disconnect();
     this.animations.forEach(animation => animation.cancel());
     this.animations.clear();
    };
    if (!this.motion.matches && 'IntersectionObserver' in window && Element.prototype.animate) {
     this.revealObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
       const element = entry.target;
       if (!entry.isIntersecting || element.hidden) return;
       this.revealObserver.unobserve(element);
       if (element.dataset.fskRevealed || element.contains(document.activeElement) || this.motion.matches) return;
       element.dataset.fskRevealed = 'true';
       const animation = element.animate(
        [{opacity:0,transform:'translateY(28px)'},{opacity:1,transform:'translateY(0)'}],
        {duration: 1250,easing:'cubic-bezier(.25,.46,.45,.94)',fill:'backwards'}
       );
       this.animations.set(element,animation);
       const done = () => { if (this.animations.get(element) === animation) this.animations.delete(element); };
       animation.addEventListener('finish',done,{once:true});
       animation.addEventListener('cancel',done,{once:true});
      });
     },{threshold:.08,rootMargin:'0px 0px -24px 0px'});
     this.querySelectorAll('[data-fsk-reveal]:not([data-fsk-revealed])').forEach(element => this.revealObserver.observe(element));
    }
    this.addEventListener('focusin',event => {
     const element = event.target.closest('[data-fsk-reveal]');
     if (element) {
      this.revealObserver?.unobserve(element);
      element.dataset.fskRevealed = 'true';
      cancelFor(element);
     }
    },{signal});
    this.motion.addEventListener('change',cancelMotion,{signal});
   };
   if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true,signal});
   else start();
  }
  disconnectedCallback() {
   this.controller?.abort();
   this.revealObserver?.disconnect();
   this.animations?.forEach(animation => animation.cancel());
   this.animations?.clear();
   this.controller = null;
   this.ready = false;
  }
 });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fsk-dermabrasion-page"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('fsk-derm-overview')) return;

  class FskDermOverview extends HTMLElement {
    constructor() {
      super();
      this._index = 0;
      this._elapsed = 0;
      this._running = false;
      this._userPaused = false;
      this._motionPaused = false;
      this._pointerFocus = false;
      this._frame = null;
      this._lastFrame = null;
      this._tick = this._tick.bind(this);
    }

    connectedCallback() {
      if (this._controller) return;
      this._panels = Array.from(this.querySelectorAll('[data-derm-panel]'));
      this._tabs = Array.from(this.querySelectorAll('[data-derm-tab]'));
      this._counter = this.querySelector('[data-derm-current]');
      this._progress = this.querySelector('[data-derm-progress]');
      this._toggle = this.querySelector('[data-derm-toggle]');
      if (!this._panels.length || !this._toggle) return;

      this._controller = new AbortController();
      const signal = this._controller.signal;
      const requestedInterval = Number(this.dataset.interval);
      this._interval = Number.isFinite(requestedInterval) && requestedInterval >= 1000
        ? requestedInterval
        : 5000;
      this._index = Math.min(this._index, this._panels.length - 1);
      this._visible = false;
      this._mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (this._motionPreference !== this._mediaQuery.matches) {
        this._motionPaused = this._mediaQuery.matches;
      }
      this._motionPreference = this._mediaQuery.matches;

      this.addEventListener('pointerdown', () => {
        this._pointerFocus = true;
      }, { signal });

      this.addEventListener('focusin', (event) => {
        if (this._pointerFocus || this.contains(event.relatedTarget)) return;
        this._userPaused = true;
        this._syncPlayback();
      }, { signal });

      this.addEventListener('click', (event) => {
        const target = event.target instanceof Element ? event.target : null;
        const tab = target?.closest('[data-derm-tab]');
        if (tab && this.contains(tab)) {
          const index = Number(tab.dataset.index);
          if (!Number.isInteger(index) || index < 0 || index >= this._panels.length) return;
          this._select(index);
          return;
        }
        if (target?.closest('[data-derm-toggle]') !== this._toggle) return;
        if (this._userPaused || this._motionPaused) {
          this._userPaused = false;
          this._motionPaused = false;
        } else {
          this._userPaused = true;
        }
        this._syncPlayback();
      }, { signal });

      document.addEventListener('keydown', (event) => {
        this._pointerFocus = false;
        const tab = event.target instanceof Element
          ? event.target.closest('[data-derm-tab]')
          : null;
        if (!tab || !this.contains(tab)) return;
        const position = this._tabs.indexOf(tab);
        let next;
        if (event.key === 'ArrowRight') next = (position + 1) % this._tabs.length;
        if (event.key === 'ArrowLeft') next = (position - 1 + this._tabs.length) % this._tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this._tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        this._select(Number(this._tabs[next].dataset.index));
        this._tabs[next].focus();
      }, { signal, capture: true });

      document.addEventListener('visibilitychange', () => {
        this._syncPlayback();
      }, { signal });

      this._mediaQuery.addEventListener('change', (event) => {
        this._motionPreference = event.matches;
        this._motionPaused = event.matches;
        this._syncPlayback();
      }, { signal });

      document.addEventListener('shopify:section:select', (event) => {
        if (!(event.target instanceof Element) || !event.target.contains(this)) return;
        this._userPaused = true;
        this._syncPlayback();
      }, { signal });

      if ('IntersectionObserver' in window) {
        this._observer = new IntersectionObserver((entries) => {
          const entry = entries.find((item) => item.target === this);
          if (!entry) return;
          this._visible = entry.isIntersecting && entry.intersectionRatio >= .15;
          this._syncPlayback();
        }, { threshold: [0, .15] });
        this._observer.observe(this);
      } else {
        this._visible = true;
      }

      this._render();
      this.setAttribute('data-ready', '');
      this._syncPlayback();
    }

    disconnectedCallback() {
      this._stop();
      this._controller?.abort();
      this._controller = null;
      this._observer?.disconnect();
      this._observer = null;
      this._mediaQuery = null;
      this._visible = false;
      this.dataset.playing = 'false';
    }

    _select(index) {
      if (!Number.isInteger(index) || index < 0 || index >= this._panels.length) return;
      this._userPaused = true;
      this._index = index;
      this._elapsed = 0;
      this._render();
      this._syncPlayback();
    }

    _render() {
      this._panels.forEach((panel, index) => {
        const active = index === this._index;
        panel.setAttribute('aria-hidden', String(!active));
        panel.inert = !active;
      });
      this._tabs.forEach((tab) => {
        tab.setAttribute('aria-pressed', String(Number(tab.dataset.index) === this._index));
      });
      if (this._counter) this._counter.textContent = String(this._index + 1).padStart(2, '0');
      this._updateProgress();
    }

    _updateProgress() {
      this._progress?.style.setProperty('--derm-progress', String(Math.min(1, this._elapsed / this._interval)));
    }

    _syncPlayback() {
      const paused = this._userPaused || this._motionPaused;
      const shouldRun = this.isConnected && this._visible && !document.hidden && !paused && this._panels.length > 1;
      this.dataset.paused = String(paused);
      this.dataset.playing = String(shouldRun);
      this._toggle.setAttribute('aria-label', paused
        ? this.dataset.playLabel || 'Animation abspielen'
        : this.dataset.pauseLabel || 'Animation pausieren');
      if (shouldRun && !this._running) {
        this._running = true;
        this._lastFrame = null;
        this._frame = requestAnimationFrame(this._tick);
      } else if (!shouldRun) {
        this._stop();
      }
    }

    _stop() {
      this._running = false;
      if (this._frame !== null) cancelAnimationFrame(this._frame);
      this._frame = null;
      this._lastFrame = null;
    }

    _tick(timestamp) {
      this._frame = null;
      if (!this._running) return;
      if (!this.isConnected || document.hidden || !this._visible) {
        this._syncPlayback();
        return;
      }
      if (this._lastFrame !== null) this._elapsed += timestamp - this._lastFrame;
      this._lastFrame = timestamp;
      if (this._elapsed >= this._interval) {
        const advances = Math.floor(this._elapsed / this._interval);
        this._elapsed %= this._interval;
        this._index = (this._index + advances) % this._panels.length;
        this._render();
      } else {
        this._updateProgress();
      }
      this._frame = requestAnimationFrame(this._tick);
    }
  }

  customElements.define('fsk-derm-overview', FskDermOverview);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fsk-fruchtsaeure-page"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('fsk-peel-overview')) return;

  class FskPeelOverview extends HTMLElement {
    constructor() {
      super();
      this._index = 0;
      this._elapsed = 0;
      this._running = false;
      this._userPaused = false;
      this._motionPaused = false;
      this._pointerFocus = false;
      this._frame = null;
      this._lastFrame = null;
      this._tick = this._tick.bind(this);
    }

    connectedCallback() {
      if (this._controller) return;
      this._panels = Array.from(this.querySelectorAll('[data-peel-panel]'));
      this._tabs = Array.from(this.querySelectorAll('[data-peel-tab]'));
      this._counter = this.querySelector('[data-peel-current]');
      this._progress = this.querySelector('[data-peel-progress]');
      this._toggle = this.querySelector('[data-peel-toggle]');
      if (!this._panels.length || !this._toggle) return;

      this._controller = new AbortController();
      const signal = this._controller.signal;
      const requestedInterval = Number(this.dataset.interval);
      this._interval = Number.isFinite(requestedInterval) && requestedInterval >= 1000
        ? requestedInterval
        : 5000;
      this._index = Math.min(this._index, this._panels.length - 1);
      this._visible = false;
      this._mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (this._motionPreference !== this._mediaQuery.matches) {
        this._motionPaused = this._mediaQuery.matches;
      }
      this._motionPreference = this._mediaQuery.matches;

      this.addEventListener('pointerdown', () => {
        this._pointerFocus = true;
      }, { signal });

      this.addEventListener('focusin', (event) => {
        if (this._pointerFocus || this.contains(event.relatedTarget)) return;
        this._userPaused = true;
        this._syncPlayback();
      }, { signal });

      this.addEventListener('click', (event) => {
        const target = event.target instanceof Element ? event.target : null;
        const tab = target?.closest('[data-peel-tab]');
        if (tab && this.contains(tab)) {
          const index = Number(tab.dataset.index);
          if (!Number.isInteger(index) || index < 0 || index >= this._panels.length) return;
          this._select(index);
          return;
        }
        if (target?.closest('[data-peel-toggle]') !== this._toggle) return;
        if (this._userPaused || this._motionPaused) {
          this._userPaused = false;
          this._motionPaused = false;
        } else {
          this._userPaused = true;
        }
        this._syncPlayback();
      }, { signal });

      document.addEventListener('keydown', (event) => {
        this._pointerFocus = false;
        const tab = event.target instanceof Element
          ? event.target.closest('[data-peel-tab]')
          : null;
        if (!tab || !this.contains(tab)) return;
        const position = this._tabs.indexOf(tab);
        let next;
        if (event.key === 'ArrowRight') next = (position + 1) % this._tabs.length;
        if (event.key === 'ArrowLeft') next = (position - 1 + this._tabs.length) % this._tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this._tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        this._select(Number(this._tabs[next].dataset.index));
        this._tabs[next].focus();
      }, { signal, capture: true });

      document.addEventListener('visibilitychange', () => {
        this._syncPlayback();
      }, { signal });

      this._mediaQuery.addEventListener('change', (event) => {
        this._motionPreference = event.matches;
        this._motionPaused = event.matches;
        this._syncPlayback();
      }, { signal });

      document.addEventListener('shopify:section:select', (event) => {
        if (!(event.target instanceof Element) || !event.target.contains(this)) return;
        this._userPaused = true;
        this._syncPlayback();
      }, { signal });

      if ('IntersectionObserver' in window) {
        this._observer = new IntersectionObserver((entries) => {
          const entry = entries.find((item) => item.target === this);
          if (!entry) return;
          this._visible = entry.isIntersecting && entry.intersectionRatio >= .15;
          this._syncPlayback();
        }, { threshold: [0, .15] });
        this._observer.observe(this);
      } else {
        this._visible = true;
      }

      this._render();
      this.setAttribute('data-ready', '');
      this._syncPlayback();
    }

    disconnectedCallback() {
      this._stop();
      this._controller?.abort();
      this._controller = null;
      this._observer?.disconnect();
      this._observer = null;
      this._mediaQuery = null;
      this._visible = false;
      this.dataset.playing = 'false';
    }

    _select(index) {
      if (!Number.isInteger(index) || index < 0 || index >= this._panels.length) return;
      this._userPaused = true;
      this._index = index;
      this._elapsed = 0;
      this._render();
      this._syncPlayback();
    }

    _render() {
      this._panels.forEach((panel, index) => {
        const active = index === this._index;
        panel.setAttribute('aria-hidden', String(!active));
        panel.inert = !active;
      });
      this._tabs.forEach((tab) => {
        tab.setAttribute('aria-pressed', String(Number(tab.dataset.index) === this._index));
      });
      if (this._counter) this._counter.textContent = String(this._index + 1).padStart(2, '0');
      this._updateProgress();
    }

    _updateProgress() {
      this._progress?.style.setProperty('--peel-progress', String(Math.min(1, this._elapsed / this._interval)));
    }

    _syncPlayback() {
      const paused = this._userPaused || this._motionPaused;
      const shouldRun = this.isConnected && this._visible && !document.hidden && !paused && this._panels.length > 1;
      this.dataset.paused = String(paused);
      this.dataset.playing = String(shouldRun);
      this._toggle.setAttribute('aria-label', paused
        ? this.dataset.playLabel || 'Animation abspielen'
        : this.dataset.pauseLabel || 'Animation pausieren');
      if (shouldRun && !this._running) {
        this._running = true;
        this._lastFrame = null;
        this._frame = requestAnimationFrame(this._tick);
      } else if (!shouldRun) {
        this._stop();
      }
    }

    _stop() {
      this._running = false;
      if (this._frame !== null) cancelAnimationFrame(this._frame);
      this._frame = null;
      this._lastFrame = null;
    }

    _tick(timestamp) {
      this._frame = null;
      if (!this._running) return;
      if (!this.isConnected || document.hidden || !this._visible) {
        this._syncPlayback();
        return;
      }
      if (this._lastFrame !== null) this._elapsed += timestamp - this._lastFrame;
      this._lastFrame = timestamp;
      if (this._elapsed >= this._interval) {
        const advances = Math.floor(this._elapsed / this._interval);
        this._elapsed %= this._interval;
        this._index = (this._index + advances) % this._panels.length;
        this._render();
      } else {
        this._updateProgress();
      }
      this._frame = requestAnimationFrame(this._tick);
    }
  }

  customElements.define('fsk-peel-overview', FskPeelOverview);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fsk-home-discover"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fsk-discover-2026')) {
    customElements.define('fsk-discover-2026', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.tabs = Array.from(this.querySelectorAll('[data-discover-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-discover-panel]'));
        const tablist = this.querySelector('[data-discover-tabs]');
        if (!tablist || !this.tabs.length || this.tabs.length !== this.panels.length) return;
        tablist.setAttribute('role', 'tablist');
        this.tabs.forEach((tab, index) => {
          tab.setAttribute('role', 'tab');
          this.panels[index].setAttribute('role', 'tabpanel');
          this.panels[index].setAttribute('aria-labelledby', tab.id);
          this.panels[index].tabIndex = 0;
          tab.addEventListener('click', () => this.select(index), options);
          tab.addEventListener('keydown', (event) => {
            let next = index;
            if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
            else if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = this.tabs.length - 1;
            else return;
            event.preventDefault();
            this.select(next);
            this.tabs[next].focus({ preventScroll: true });
          }, options);
        });
        const selected = this.tabs.findIndex((tab) => tab.dataset.discoverTab === this.selectedBlock);
        this.select(selected >= 0 ? selected : 0);
        this.setAttribute('data-enhanced', '');
        tablist.hidden = this.tabs.length < 2;
        if (window.Shopify?.designMode) {
          document.addEventListener('shopify:block:select', (event) => {
            const index = this.panels.findIndex((panel) => panel.dataset.discoverPanel === event.detail?.blockId);
            if (index >= 0) this.select(index);
          }, options);
        }
      }
      select(index) {
        if (!this.tabs[index]) return;
        this.selectedBlock = this.tabs[index].dataset.discoverTab;
        this.tabs.forEach((tab, tabIndex) => {
          const selected = tabIndex === index;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
          this.panels[tabIndex].hidden = !selected;
        });
      }
      disconnectedCallback() {
        this.controller?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fsk-home-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('fsk-hero-showcase')) {
  customElements.define('fsk-hero-showcase', class extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this._abort = new AbortController();
      this._slides = Array.from(this.querySelectorAll('[data-hero-slide]'));
      this._dots = Array.from(this.querySelectorAll('[data-hero-dot]'));
      this._index = Math.max(0, this._slides.findIndex(slide => !slide.hidden));
      this._requestedIndex = this._index;
      this._generation = 0;
      this._loading = false;
      this._paused = this.dataset.autoplay !== 'true';
      this._playFocusElement = null;
      this._toggleResume = null;
      this._focused = this.contains(document.activeElement) && document.activeElement.matches(':focus-visible');
      this._visible = !('IntersectionObserver' in window);
      this._motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this._interval = Math.max(3000, Number(this.dataset.interval) || 4000);
      this._toggle = this.querySelector('[data-hero-toggle]');
      this._status = this.querySelector('[data-hero-status]');
      this._suppressClickUntil = 0;
      const signal = this._abort.signal;
      const on = (target, type, callback, options = {}) => target?.addEventListener(type, callback, { ...options, signal });
      this.querySelectorAll('[data-hero-controls]').forEach(control => { control.hidden = this._slides.length < 2; });
      if (!this._slides.length) return;
      this._render();
      this._preload(this._index + 1);
      on(this.querySelector('[data-hero-next]'), 'click', () => this._move(1));
      on(this.querySelector('[data-hero-prev]'), 'click', () => this._move(-1));
      this._dots.forEach(dot => on(dot, 'click', () => {
        const index = Number(dot.dataset.heroDot);
        if (Number.isInteger(index) && index >= 0 && index < this._slides.length) this._show(index, true, index < this._index ? -1 : 1);
      }));
      on(this._toggle, 'pointerdown', () => {
        this._toggleResume = this._paused || this._focused;
      });
      on(this._toggle, 'click', () => {
        if (this._motion.matches) return;
        const resume = this._toggleResume ?? (this._paused || this._focused);
        this._toggleResume = null;
        this._paused = !resume;
        this._playFocusElement = resume ? document.activeElement : null;
        this._syncFocus();
        this._updateToggle();
        this._schedule();
      });
      on(this, 'focusin', () => {
        this._syncFocus();
        this._updateToggle();
        this._schedule();
      });
      on(this, 'focusout', () => queueMicrotask(() => {
        if (signal.aborted) return;
        this._syncFocus();
        this._updateToggle();
        this._schedule();
      }));
      on(this, 'keydown', event => {
        this._toggleResume = null;
        if (['Tab', 'ArrowLeft', 'ArrowRight'].includes(event.key)) {
          this._playFocusElement = null;
          this._focused = true;
          this._updateToggle();
          this._schedule();
        }
        if (!(event.target instanceof Element) || !event.target.closest('[data-hero-controls]') || event.altKey || event.ctrlKey || event.metaKey) return;
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this._move(event.key === 'ArrowRight' ? 1 : -1);
      });
      on(this, 'pointerdown', event => {
        if (event.target instanceof Element && !event.target.closest('[data-hero-toggle]')) {
          this._playFocusElement = null;
          this._focused = false;
          this._updateToggle();
          this._schedule();
        }
        this._touch = event.pointerType === 'touch' && event.isPrimary && event.target instanceof Element && event.target.closest('[data-hero-slide]') ? { id: event.pointerId, x: event.clientX, y: event.clientY, time: performance.now() } : null;
      }, { passive: true });
      on(this, 'pointercancel', () => { this._touch = null; this._toggleResume = null; }, { passive: true });
      on(this, 'pointerup', event => {
        const start = this._touch;
        this._touch = null;
        if (!start || event.pointerId !== start.id || performance.now() - start.time > 1000) return;
        const x = event.clientX - start.x;
        const y = event.clientY - start.y;
        if (Math.abs(x) < 45 || Math.abs(x) < Math.abs(y) * 1.5) return;
        this._suppressClickUntil = performance.now() + 500;
        this._move(x < 0 ? 1 : -1);
      }, { passive: true });
      on(this, 'click', event => {
        if (performance.now() < this._suppressClickUntil && event.target instanceof Element && event.target.closest('[data-hero-slide]')) {
          event.preventDefault();
          event.stopPropagation();
        }
      }, { capture: true });
      on(document, 'visibilitychange', () => this._schedule());
      on(this._motion, 'change', () => {
        if (this._motion.matches) this._animation?.cancel();
        this._updateToggle();
        this._schedule();
      });
      on(document, 'shopify:block:select', event => {
        const index = this._slides.findIndex(slide => slide.dataset.blockId === String(event.detail?.blockId));
        if (index >= 0) {
          this._paused = true;
          this._show(index, true);
        }
      });
      if ('IntersectionObserver' in window) {
        this._observer = new IntersectionObserver(entries => {
          this._visible = entries.some(entry => entry.isIntersecting && entry.intersectionRatio >= 0.15);
          this._schedule();
        }, { threshold: [0, 0.15] });
        this._observer.observe(this);
      }
      this._schedule();
    }

    disconnectedCallback() {
      this._generation++;
      clearTimeout(this._timer);
      this._animation?.cancel();
      this._observer?.disconnect();
      this._abort?.abort();
      this._touch = null;
      this._ready = false;
    }

    _syncFocus() {
      const active = document.activeElement;
      if (active !== this._playFocusElement) this._playFocusElement = null;
      this._focused = this.contains(active) && active.matches(':focus-visible') && active !== this._playFocusElement;
    }

    _canRun() {
      return this._ready && this._slides.length > 1 && !this._paused && !this._motion.matches && !this._focused && this._visible && !document.hidden;
    }

    _schedule() {
      clearTimeout(this._timer);
      if (this._canRun() && !this._loading) this._timer = setTimeout(() => this._show(this._index + 1), this._interval);
    }

    _updateToggle() {
      if (!this._toggle) return;
      const playing = !this._paused && !this._focused && !this._motion.matches;
      this._toggle.disabled = this._motion.matches;
      this._toggle.setAttribute('aria-label', playing ? this._toggle.dataset.labelPause : this._toggle.dataset.labelPlay);
      this._toggle.querySelectorAll('[data-hero-play]').forEach(icon => { icon.toggleAttribute('hidden', playing); });
      this._toggle.querySelectorAll('[data-hero-pause]').forEach(icon => { icon.toggleAttribute('hidden', !playing); });
    }

    _render() {
      this._slides.forEach((slide, index) => {
        const active = index === this._index;
        slide.hidden = !active;
        slide.inert = !active;
        slide.setAttribute('aria-hidden', String(!active));
      });
      this._dots.forEach(dot => {
        if (Number(dot.dataset.heroDot) === this._index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      this.querySelectorAll('[data-hero-current]').forEach(counter => { counter.textContent = String(this._index + 1).padStart(2, '0'); });
      this._updateToggle();
    }

    _preload(index) {
      const slide = this._slides[(index + this._slides.length) % this._slides.length];
      const image = slide?.querySelector('img');
      if (image) image.loading = 'eager';
      return image;
    }

    _move(direction) {
      this._show(this._requestedIndex + direction, true, direction);
    }

    async _show(index, manual = false, direction = 1) {
      if (!this._slides.length) return;
      index = (index + this._slides.length) % this._slides.length;
      const generation = ++this._generation;
      const signal = this._abort.signal;
      this._requestedIndex = index;
      clearTimeout(this._timer);
      this._updateToggle();
      this._loading = index !== this._index;
      const image = this._preload(index);
      if (this._loading && image && !image.complete && typeof image.decode === 'function') {
        await new Promise(resolve => {
          let settled = false;
          const finish = () => {
            if (settled) return;
            settled = true;
            clearTimeout(timer);
            signal.removeEventListener('abort', finish);
            resolve();
          };
          const timer = setTimeout(finish, 1200);
          signal.addEventListener('abort', finish, { once: true });
          image.decode().then(finish, finish);
        });
      }
      if (signal.aborted || generation !== this._generation) return;
      this._loading = false;
      if (!manual && !this._canRun()) {
        this._requestedIndex = this._index;
        this._schedule();
        return;
      }
      const changed = index !== this._index;
      this._animation?.cancel();
      this._index = index;
      this._render();
      const slide = this._slides[index];
      if (changed && !this._motion.matches && typeof slide.animate === 'function') {
        this._animation = slide.animate([
          { opacity: 0, transform: `translateX(${direction < 0 ? -12 : 12}px)` },
          { opacity: 1, transform: 'translateX(0)' }
        ], { duration: 450, easing: 'cubic-bezier(.22,.61,.36,1)' });
      }
      if (manual && this._status) this._status.textContent = slide.dataset.title || '';
      this._preload(index + 1);
      this._schedule();
    }
  });
}

if(!customElements.get('fsk-hero-video-2026')){
  customElements.define('fsk-hero-video-2026',class extends HTMLElement{
    connectedCallback(){
      this.controller?.abort();
      this.observer?.disconnect();
      this.video=this.querySelector('video');
      this.button=this.querySelector('[data-video-toggle]');
      if(!this.video||!this.button)return;
      this.controller=new AbortController();
      const options={signal:this.controller.signal};
      this.motion=window.matchMedia('(prefers-reduced-motion: reduce)');
      this.visible=false;
      this.userPaused=this.userPaused??false;
      this.manualPlayback=this.manualPlayback??false;
      this.video.muted=true;
      this.video.controls=false;
      this.button.hidden=false;
      this.button.addEventListener('click',()=>{
        if(this.video.paused){
          this.userPaused=false;
          this.manualPlayback=true;
          if(!('IntersectionObserver' in window))this.visible=true;
        }else{
          this.userPaused=true;
          this.manualPlayback=false;
        }
        this.syncPlayback();
      },options);
      this.video.addEventListener('play',()=>this.syncButton(),options);
      this.video.addEventListener('pause',()=>this.syncButton(),options);
      this.video.addEventListener('ended',()=>this.syncButton(),options);
      this.motion.addEventListener('change',()=>{
        if(this.motion.matches)this.manualPlayback=false;
        this.syncPlayback();
      },options);
      document.addEventListener('visibilitychange',()=>this.syncPlayback(),options);
      if('IntersectionObserver' in window){
        this.observer=new IntersectionObserver((entries)=>{
          this.visible=entries.some(entry=>entry.isIntersecting&&entry.intersectionRatio>=.35);
          this.syncPlayback();
        },{threshold:[0,.35]});
        this.observer.observe(this.video);
      }
      this.syncButton();
    }
    shouldPlay(){
      return this.visible&&!document.hidden&&!this.userPaused&&(!this.motion.matches||this.manualPlayback);
    }
    syncPlayback(){
      if(!this.shouldPlay()){
        this.video.pause();
        this.syncButton();
        return;
      }
      if(!this.video.paused)return;
      const playback=this.video.play();
      playback?.then(()=>{
        if(!this.isConnected||!this.shouldPlay())this.video.pause();
        this.syncButton();
      }).catch(()=>this.syncButton());
    }
    syncButton(){
      const playing=!this.video.paused&&!this.video.ended;
      this.dataset.playing=String(playing);
      this.button.setAttribute('aria-pressed',String(playing));
    }
    disconnectedCallback(){
      this.controller?.abort();
      this.observer?.disconnect();
      this.video?.pause();
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fsk-home-studio"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('fsk-studio-video-2026')){
  customElements.define('fsk-studio-video-2026',class extends HTMLElement{
    connectedCallback(){
      this.controller?.abort();
      this.observer?.disconnect();
      this.video=this.querySelector('video');
      this.button=this.querySelector('[data-video-toggle]');
      if(!this.video||!this.button)return;
      this.controller=new AbortController();
      const options={signal:this.controller.signal};
      this.motion=window.matchMedia('(prefers-reduced-motion: reduce)');
      this.visible=false;
      this.userPaused=this.userPaused??false;
      this.manualPlayback=this.manualPlayback??false;
      this.video.muted=true;
      this.video.controls=false;
      this.button.hidden=false;
      this.button.addEventListener('click',()=>{
        if(this.video.paused){
          this.userPaused=false;
          this.manualPlayback=true;
          if(!('IntersectionObserver' in window))this.visible=true;
        }else{
          this.userPaused=true;
          this.manualPlayback=false;
        }
        this.syncPlayback();
      },options);
      this.video.addEventListener('play',()=>this.syncButton(),options);
      this.video.addEventListener('pause',()=>this.syncButton(),options);
      this.video.addEventListener('ended',()=>this.syncButton(),options);
      this.motion.addEventListener('change',()=>{
        if(this.motion.matches)this.manualPlayback=false;
        this.syncPlayback();
      },options);
      document.addEventListener('visibilitychange',()=>this.syncPlayback(),options);
      if('IntersectionObserver' in window){
        this.observer=new IntersectionObserver((entries)=>{
          this.visible=entries.some(entry=>entry.isIntersecting&&entry.intersectionRatio>=.35);
          this.syncPlayback();
        },{threshold:[0,.35]});
        this.observer.observe(this.video);
      }
      this.syncButton();
    }
    shouldPlay(){
      return this.visible&&!document.hidden&&!this.userPaused&&(!this.motion.matches||this.manualPlayback);
    }
    syncPlayback(){
      if(!this.shouldPlay()){
        this.video.pause();
        this.syncButton();
        return;
      }
      if(!this.video.paused)return;
      const playback=this.video.play();
      playback?.then(()=>{
        if(!this.isConnected||!this.shouldPlay())this.video.pause();
        this.syncButton();
      }).catch(()=>this.syncButton());
    }
    syncButton(){
      const playing=!this.video.paused&&!this.video.ended;
      this.dataset.playing=String(playing);
      this.button.setAttribute('aria-pressed',String(playing));
    }
    disconnectedCallback(){
      this.controller?.abort();
      this.observer?.disconnect();
      this.video?.pause();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fsk-home-treatments"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fsk-compact-treatment-2026')) {
    customElements.define('fsk-compact-treatment-2026', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.syncHeroSize();
        document.addEventListener('shopify:section:load', () => this.syncHeroSize(), options);
        document.addEventListener('shopify:section:unload', () => requestAnimationFrame(() => { if (this.isConnected) this.syncHeroSize(); }), options);
        this.addEventListener('toggle', (event) => {
          const selected = event.target;
          if (!(selected instanceof HTMLDetailsElement) || !selected.open) return;
          this.querySelectorAll('details[open]').forEach((details) => {
            if (details !== selected) details.open = false;
          });
        }, { ...options, capture: true });
        if (window.Shopify?.designMode) {
          document.addEventListener('shopify:block:select', (event) => {
            const blockId = event.detail?.blockId;
            if (!blockId) return;
            const row = Array.from(this.querySelectorAll('[data-treatment-block-id]')).find((item) => item.dataset.treatmentBlockId === blockId);
            const details = row?.closest('details');
            if (details) details.open = true;
          }, options);
        }
      }
      syncHeroSize() {
        this.mediaObserver?.disconnect();
        const hero = document.querySelector('.fsk-home-hero__visual--video');
        if (!hero || !this.querySelector('.fsk-compact-treatments__portrait')) {
          this.style.removeProperty('--fsk-treatment-media-height');
          return;
        }
        const sync = () => {
          const height = hero.getBoundingClientRect().height;
          if (height > 0) this.style.setProperty('--fsk-treatment-media-height', height + 'px');
        };
        sync();
        if ('ResizeObserver' in window) {
          this.mediaObserver = new ResizeObserver(sync);
          this.mediaObserver.observe(hero);
        }
      }
      disconnectedCallback() {
        this.mediaObserver?.disconnect();
        this.controller?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fsk-hydrafacial-page"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('fsk-hydra-overview')) return;

  class FskHydraOverview extends HTMLElement {
    constructor() {
      super();
      this._index = 0;
      this._elapsed = 0;
      this._running = false;
      this._userPaused = false;
      this._motionPaused = false;
      this._pointerFocus = false;
      this._frame = null;
      this._lastFrame = null;
      this._tick = this._tick.bind(this);
    }

    connectedCallback() {
      if (this._controller) return;
      this._panels = Array.from(this.querySelectorAll('[data-hydra-panel]'));
      this._tabs = Array.from(this.querySelectorAll('[data-hydra-tab]'));
      this._counter = this.querySelector('[data-hydra-current]');
      this._progress = this.querySelector('[data-hydra-progress]');
      this._toggle = this.querySelector('[data-hydra-toggle]');
      if (!this._panels.length || !this._toggle) return;

      this._controller = new AbortController();
      const signal = this._controller.signal;
      const requestedInterval = Number(this.dataset.interval);
      this._interval = Number.isFinite(requestedInterval) && requestedInterval >= 1000
        ? requestedInterval
        : 5000;
      this._index = Math.min(this._index, this._panels.length - 1);
      this._visible = false;
      this._mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (this._motionPreference !== this._mediaQuery.matches) {
        this._motionPaused = this._mediaQuery.matches;
      }
      this._motionPreference = this._mediaQuery.matches;

      this.addEventListener('pointerdown', () => {
        this._pointerFocus = true;
      }, { signal });

      this.addEventListener('focusin', (event) => {
        if (this._pointerFocus || this.contains(event.relatedTarget)) return;
        this._userPaused = true;
        this._syncPlayback();
      }, { signal });

      this.addEventListener('click', (event) => {
        const target = event.target instanceof Element ? event.target : null;
        const tab = target?.closest('[data-hydra-tab]');
        if (tab && this.contains(tab)) {
          const index = Number(tab.dataset.index);
          if (!Number.isInteger(index) || index < 0 || index >= this._panels.length) return;
          this._select(index);
          return;
        }
        if (target?.closest('[data-hydra-toggle]') !== this._toggle) return;
        if (this._userPaused || this._motionPaused) {
          this._userPaused = false;
          this._motionPaused = false;
        } else {
          this._userPaused = true;
        }
        this._syncPlayback();
      }, { signal });

      document.addEventListener('keydown', (event) => {
        this._pointerFocus = false;
        const tab = event.target instanceof Element
          ? event.target.closest('[data-hydra-tab]')
          : null;
        if (!tab || !this.contains(tab)) return;
        const position = this._tabs.indexOf(tab);
        let next;
        if (event.key === 'ArrowRight') next = (position + 1) % this._tabs.length;
        if (event.key === 'ArrowLeft') next = (position - 1 + this._tabs.length) % this._tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this._tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        this._select(Number(this._tabs[next].dataset.index));
        this._tabs[next].focus();
      }, { signal, capture: true });

      document.addEventListener('visibilitychange', () => {
        this._syncPlayback();
      }, { signal });

      this._mediaQuery.addEventListener('change', (event) => {
        this._motionPreference = event.matches;
        this._motionPaused = event.matches;
        this._syncPlayback();
      }, { signal });

      document.addEventListener('shopify:section:select', (event) => {
        if (!(event.target instanceof Element) || !event.target.contains(this)) return;
        this._userPaused = true;
        this._syncPlayback();
      }, { signal });

      if ('IntersectionObserver' in window) {
        this._observer = new IntersectionObserver((entries) => {
          const entry = entries.find((item) => item.target === this);
          if (!entry) return;
          this._visible = entry.isIntersecting && entry.intersectionRatio >= .15;
          this._syncPlayback();
        }, { threshold: [0, .15] });
        this._observer.observe(this);
      } else {
        this._visible = true;
      }

      this._render();
      this.setAttribute('data-ready', '');
      this._syncPlayback();
    }

    disconnectedCallback() {
      this._stop();
      this._controller?.abort();
      this._controller = null;
      this._observer?.disconnect();
      this._observer = null;
      this._mediaQuery = null;
      this._visible = false;
      this.dataset.playing = 'false';
    }

    _select(index) {
      if (!Number.isInteger(index) || index < 0 || index >= this._panels.length) return;
      this._userPaused = true;
      this._index = index;
      this._elapsed = 0;
      this._render();
      this._syncPlayback();
    }

    _render() {
      this._panels.forEach((panel, index) => {
        const active = index === this._index;
        panel.setAttribute('aria-hidden', String(!active));
        panel.inert = !active;
      });
      this._tabs.forEach((tab) => {
        tab.setAttribute('aria-pressed', String(Number(tab.dataset.index) === this._index));
      });
      if (this._counter) this._counter.textContent = String(this._index + 1).padStart(2, '0');
      this._updateProgress();
    }

    _updateProgress() {
      this._progress?.style.setProperty('--hydra-progress', String(Math.min(1, this._elapsed / this._interval)));
    }

    _syncPlayback() {
      const paused = this._userPaused || this._motionPaused;
      const shouldRun = this.isConnected && this._visible && !document.hidden && !paused && this._panels.length > 1;
      this.dataset.paused = String(paused);
      this.dataset.playing = String(shouldRun);
      this._toggle.setAttribute('aria-label', paused
        ? this.dataset.playLabel || 'Animation abspielen'
        : this.dataset.pauseLabel || 'Animation pausieren');
      if (shouldRun && !this._running) {
        this._running = true;
        this._lastFrame = null;
        this._frame = requestAnimationFrame(this._tick);
      } else if (!shouldRun) {
        this._stop();
      }
    }

    _stop() {
      this._running = false;
      if (this._frame !== null) cancelAnimationFrame(this._frame);
      this._frame = null;
      this._lastFrame = null;
    }

    _tick(timestamp) {
      this._frame = null;
      if (!this._running) return;
      if (!this.isConnected || document.hidden || !this._visible) {
        this._syncPlayback();
        return;
      }
      if (this._lastFrame !== null) this._elapsed += timestamp - this._lastFrame;
      this._lastFrame = timestamp;
      if (this._elapsed >= this._interval) {
        const advances = Math.floor(this._elapsed / this._interval);
        this._elapsed %= this._interval;
        this._index = (this._index + advances) % this._panels.length;
        this._render();
      } else {
        this._updateProgress();
      }
      this._frame = requestAnimationFrame(this._tick);
    }
  }

  customElements.define('fsk-hydra-overview', FskHydraOverview);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fsk-maennerkosmetik-page"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('fsk-men-overview')) return;

  class FskMenOverview extends HTMLElement {
    constructor() {
      super();
      this._index = 0;
      this._elapsed = 0;
      this._running = false;
      this._userPaused = false;
      this._motionPaused = false;
      this._pointerFocus = false;
      this._frame = null;
      this._lastFrame = null;
      this._tick = this._tick.bind(this);
    }

    connectedCallback() {
      if (this._controller) return;
      this._panels = Array.from(this.querySelectorAll('[data-men-panel]'));
      this._tabs = Array.from(this.querySelectorAll('[data-men-tab]'));
      this._counter = this.querySelector('[data-men-current]');
      this._progress = this.querySelector('[data-men-progress]');
      this._toggle = this.querySelector('[data-men-toggle]');
      if (!this._panels.length || !this._toggle) return;

      this._controller = new AbortController();
      const signal = this._controller.signal;
      const requestedInterval = Number(this.dataset.interval);
      this._interval = Number.isFinite(requestedInterval) && requestedInterval >= 1000
        ? requestedInterval
        : 5000;
      this._index = Math.min(this._index, this._panels.length - 1);
      this._visible = false;
      this._mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (this._motionPreference !== this._mediaQuery.matches) {
        this._motionPaused = this._mediaQuery.matches;
      }
      this._motionPreference = this._mediaQuery.matches;

      this.addEventListener('pointerdown', () => {
        this._pointerFocus = true;
      }, { signal });

      this.addEventListener('focusin', (event) => {
        if (this._pointerFocus || this.contains(event.relatedTarget)) return;
        this._userPaused = true;
        this._syncPlayback();
      }, { signal });

      this.addEventListener('click', (event) => {
        const target = event.target instanceof Element ? event.target : null;
        const tab = target?.closest('[data-men-tab]');
        if (tab && this.contains(tab)) {
          const index = Number(tab.dataset.index);
          if (!Number.isInteger(index) || index < 0 || index >= this._panels.length) return;
          this._select(index);
          return;
        }
        if (target?.closest('[data-men-toggle]') !== this._toggle) return;
        if (this._userPaused || this._motionPaused) {
          this._userPaused = false;
          this._motionPaused = false;
        } else {
          this._userPaused = true;
        }
        this._syncPlayback();
      }, { signal });

      document.addEventListener('keydown', (event) => {
        this._pointerFocus = false;
        const tab = event.target instanceof Element
          ? event.target.closest('[data-men-tab]')
          : null;
        if (!tab || !this.contains(tab)) return;
        const position = this._tabs.indexOf(tab);
        let next;
        if (event.key === 'ArrowRight') next = (position + 1) % this._tabs.length;
        if (event.key === 'ArrowLeft') next = (position - 1 + this._tabs.length) % this._tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this._tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        this._select(Number(this._tabs[next].dataset.index));
        this._tabs[next].focus();
      }, { signal, capture: true });

      document.addEventListener('visibilitychange', () => {
        this._syncPlayback();
      }, { signal });

      this._mediaQuery.addEventListener('change', (event) => {
        this._motionPreference = event.matches;
        this._motionPaused = event.matches;
        this._syncPlayback();
      }, { signal });

      document.addEventListener('shopify:section:select', (event) => {
        if (!(event.target instanceof Element) || !event.target.contains(this)) return;
        this._userPaused = true;
        this._syncPlayback();
      }, { signal });

      if ('IntersectionObserver' in window) {
        this._observer = new IntersectionObserver((entries) => {
          const entry = entries.find((item) => item.target === this);
          if (!entry) return;
          this._visible = entry.isIntersecting && entry.intersectionRatio >= .15;
          this._syncPlayback();
        }, { threshold: [0, .15] });
        this._observer.observe(this);
      } else {
        this._visible = true;
      }

      this._render();
      this.setAttribute('data-ready', '');
      this._syncPlayback();
    }

    disconnectedCallback() {
      this._stop();
      this._controller?.abort();
      this._controller = null;
      this._observer?.disconnect();
      this._observer = null;
      this._mediaQuery = null;
      this._visible = false;
      this.dataset.playing = 'false';
    }

    _select(index) {
      if (!Number.isInteger(index) || index < 0 || index >= this._panels.length) return;
      this._userPaused = true;
      this._index = index;
      this._elapsed = 0;
      this._render();
      this._syncPlayback();
    }

    _render() {
      this._panels.forEach((panel, index) => {
        const active = index === this._index;
        panel.setAttribute('aria-hidden', String(!active));
        panel.inert = !active;
      });
      this._tabs.forEach((tab) => {
        tab.setAttribute('aria-pressed', String(Number(tab.dataset.index) === this._index));
      });
      if (this._counter) this._counter.textContent = String(this._index + 1).padStart(2, '0');
      this._updateProgress();
    }

    _updateProgress() {
      this._progress?.style.setProperty('--men-progress', String(Math.min(1, this._elapsed / this._interval)));
    }

    _syncPlayback() {
      const paused = this._userPaused || this._motionPaused;
      const shouldRun = this.isConnected && this._visible && !document.hidden && !paused && this._panels.length > 1;
      this.dataset.paused = String(paused);
      this.dataset.playing = String(shouldRun);
      this._toggle.setAttribute('aria-label', paused
        ? this.dataset.playLabel || 'Animation abspielen'
        : this.dataset.pauseLabel || 'Animation pausieren');
      if (shouldRun && !this._running) {
        this._running = true;
        this._lastFrame = null;
        this._frame = requestAnimationFrame(this._tick);
      } else if (!shouldRun) {
        this._stop();
      }
    }

    _stop() {
      this._running = false;
      if (this._frame !== null) cancelAnimationFrame(this._frame);
      this._frame = null;
      this._lastFrame = null;
    }

    _tick(timestamp) {
      this._frame = null;
      if (!this._running) return;
      if (!this.isConnected || document.hidden || !this._visible) {
        this._syncPlayback();
        return;
      }
      if (this._lastFrame !== null) this._elapsed += timestamp - this._lastFrame;
      this._lastFrame = timestamp;
      if (this._elapsed >= this._interval) {
        const advances = Math.floor(this._elapsed / this._interval);
        this._elapsed %= this._interval;
        this._index = (this._index + advances) % this._panels.length;
        this._render();
      } else {
        this._updateProgress();
      }
      this._frame = requestAnimationFrame(this._tick);
    }
  }

  customElements.define('fsk-men-overview', FskMenOverview);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fsk-micro-test"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('fsk-micro-story')) {
  customElements.define('fsk-micro-story', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.animations = new Set();
      const cancelMotion = () => {
        this.observer?.disconnect();
        this.animations.forEach(animation => animation.cancel());
        this.animations.clear();
      };
      const start = () => {
        this.setupPersonalTile();
        if (this.motion.matches || !('IntersectionObserver' in window) || !Element.prototype.animate) return;
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            this.observer.unobserve(entry.target);
            if (entry.target.contains(document.activeElement) || this.motion.matches) return;
            const delay = parseFloat(getComputedStyle(entry.target).getPropertyValue('--micro-delay')) || 0;
            const animation = entry.target.animate([
              { opacity: 0, transform: 'translateY(28px)' },
              { opacity: 1, transform: 'translateY(0)' }
            ], { duration: 1250, delay, easing: 'cubic-bezier(.25,.46,.45,.94)', fill: 'backwards' });
            this.animations.add(animation);
            const done = () => this.animations.delete(animation);
            animation.addEventListener('finish', done, {once:true});
            animation.addEventListener('cancel', done, {once:true});
            entry.target.dataset.microRevealed = 'true';
          });
        }, {threshold:.08, rootMargin:'0px 0px -24px 0px'});
        this.querySelectorAll('[data-micro-reveal]').forEach(element => this.observer.observe(element));
      };
      this.addEventListener('focusin', event => {
        const region = event.target.closest('[data-micro-reveal]');
        if (region) {
          this.observer?.unobserve(region);
          region.getAnimations().forEach(animation => animation.cancel());
        }
      }, {signal:this.controller.signal});
      this.motion.addEventListener('change', cancelMotion, {signal:this.controller.signal});
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', start, {once:true,signal:this.controller.signal});
      } else start();
    }
    setupPersonalTile() {
      const photo = this.querySelector('.fsk-micro__personal-photo');
      const copy = this.querySelector('.fsk-micro__personal-copy');
      if (!photo || !copy) return;
      const signal = this.controller.signal;
      const desktop = window.matchMedia('(min-width: 750px)');
      let lastHeight = 0;
      const measure = () => {
        this.personalFrame = null;
        if (signal.aborted || !this.isConnected || !desktop.matches) return;
        let height = copy.getBoundingClientRect().height;
        if (!height || !copy.getBoundingClientRect().width) return;
        // Match the closed card, even if one or more disclosures are already open.
        copy.querySelectorAll('details[open]').forEach(detail => {
          const summary = detail.querySelector(':scope > summary');
          if (!summary) return;
          const style = getComputedStyle(detail);
          const frame = ['borderTopWidth','borderBottomWidth','paddingTop','paddingBottom']
            .reduce((total,property) => total + (parseFloat(style[property]) || 0),0);
          const closedHeight = summary.getBoundingClientRect().height + frame;
          height -= Math.max(0,detail.getBoundingClientRect().height - closedHeight);
        });
        if (height > 0 && Math.abs(height - lastHeight) > .1) {
          photo.style.setProperty('--personal-tile-height',height + 'px');
          lastHeight = height;
        }
      };
      const schedule = () => {
        if (this.personalFrame) cancelAnimationFrame(this.personalFrame);
        this.personalFrame = requestAnimationFrame(measure);
      };
      measure();
      if ('ResizeObserver' in window) {
        this.personalObserver = new ResizeObserver(schedule);
        this.personalObserver.observe(copy);
      } else window.addEventListener('resize',schedule,{signal});
      desktop.addEventListener('change',schedule,{signal});
      copy.addEventListener('toggle',schedule,{capture:true,signal});
      if (document.fonts) document.fonts.ready.then(() => {if (!signal.aborted) schedule();});
    }
    disconnectedCallback() {
      this.personalObserver?.disconnect();
      if (this.personalFrame) cancelAnimationFrame(this.personalFrame);
      this.controller?.abort();
      this.observer?.disconnect();
      this.animations?.forEach(animation => animation.cancel());
    }
  });
}

(() => {
  if (customElements.get('fsk-micro-focus')) return;

  class FskMicroFocus extends HTMLElement {
    constructor() {
      super();
      this._index = 0;
      this._elapsed = 0;
      this._running = false;
      this._userPaused = false;
      this._motionPaused = false;
      this._pointerFocus = false;
      this._frame = null;
      this._lastFrame = null;
      this._tick = this._tick.bind(this);
    }

    connectedCallback() {
      if (this._controller) return;
      this._panels = Array.from(this.querySelectorAll('[data-micro-focus-panel]'));
      this._tabs = Array.from(this.querySelectorAll('[data-micro-focus-tab]'));
      this._counter = this.querySelector('[data-micro-focus-current]');
      this._progress = this.querySelector('[data-micro-focus-progress]');
      this._toggle = this.querySelector('[data-micro-focus-toggle]');
      if (!this._panels.length || !this._toggle) return;

      this._controller = new AbortController();
      const signal = this._controller.signal;
      const requestedInterval = Number(this.dataset.interval);
      this._interval = Number.isFinite(requestedInterval) && requestedInterval >= 1000
        ? requestedInterval
        : 5000;
      this._index = Math.min(this._index, this._panels.length - 1);
      this._visible = false;
      this._mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (this._motionPreference !== this._mediaQuery.matches) {
        this._motionPaused = this._mediaQuery.matches;
      }
      this._motionPreference = this._mediaQuery.matches;

      this.addEventListener('pointerdown', () => {
        this._pointerFocus = true;
      }, { signal });

      this.addEventListener('focusin', (event) => {
        if (this._pointerFocus || this.contains(event.relatedTarget)) return;
        this._userPaused = true;
        this._syncPlayback();
      }, { signal });

      this.addEventListener('click', (event) => {
        const target = event.target instanceof Element ? event.target : null;
        const tab = target?.closest('[data-micro-focus-tab]');
        if (tab && this.contains(tab)) {
          const index = Number(tab.dataset.index);
          if (!Number.isInteger(index) || index < 0 || index >= this._panels.length) return;
          this._select(index);
          return;
        }
        if (target?.closest('[data-micro-focus-toggle]') !== this._toggle) return;
        if (this._userPaused || this._motionPaused) {
          this._userPaused = false;
          this._motionPaused = false;
        } else {
          this._userPaused = true;
        }
        this._syncPlayback();
      }, { signal });

      document.addEventListener('keydown', (event) => {
        this._pointerFocus = false;
        const tab = event.target instanceof Element
          ? event.target.closest('[data-micro-focus-tab]')
          : null;
        if (!tab || !this.contains(tab)) return;
        const position = this._tabs.indexOf(tab);
        let next;
        if (event.key === 'ArrowRight') next = (position + 1) % this._tabs.length;
        if (event.key === 'ArrowLeft') next = (position - 1 + this._tabs.length) % this._tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this._tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        this._select(Number(this._tabs[next].dataset.index));
        this._tabs[next].focus();
      }, { signal, capture: true });

      document.addEventListener('visibilitychange', () => {
        this._syncPlayback();
      }, { signal });

      this._mediaQuery.addEventListener('change', (event) => {
        this._motionPreference = event.matches;
        this._motionPaused = event.matches;
        this._syncPlayback();
      }, { signal });

      document.addEventListener('shopify:section:select', (event) => {
        if (!(event.target instanceof Element) || !event.target.contains(this)) return;
        this._userPaused = true;
        this._syncPlayback();
      }, { signal });

      if ('IntersectionObserver' in window) {
        this._observer = new IntersectionObserver((entries) => {
          const entry = entries.find((item) => item.target === this);
          if (!entry) return;
          this._visible = entry.isIntersecting && entry.intersectionRatio >= .15;
          this._syncPlayback();
        }, { threshold: [0, .15] });
        this._observer.observe(this);
      } else {
        this._visible = true;
      }

      this._render();
      this.setAttribute('data-ready', '');
      this._syncPlayback();
    }

    disconnectedCallback() {
      this._stop();
      this._controller?.abort();
      this._controller = null;
      this._observer?.disconnect();
      this._observer = null;
      this._mediaQuery = null;
      this._visible = false;
      this.dataset.playing = 'false';
    }

    _select(index) {
      if (!Number.isInteger(index) || index < 0 || index >= this._panels.length) return;
      this._userPaused = true;
      this._index = index;
      this._elapsed = 0;
      this._render();
      this._syncPlayback();
    }

    _render() {
      this._panels.forEach((panel, index) => {
        const active = index === this._index;
        panel.setAttribute('aria-hidden', String(!active));
        panel.inert = !active;
      });
      this._tabs.forEach((tab) => {
        tab.setAttribute('aria-pressed', String(Number(tab.dataset.index) === this._index));
      });
      if (this._counter) this._counter.textContent = String(this._index + 1).padStart(2, '0');
      this._updateProgress();
    }

    _updateProgress() {
      this._progress?.style.setProperty('--micro-progress', String(Math.min(1, this._elapsed / this._interval)));
    }

    _syncPlayback() {
      const paused = this._userPaused || this._motionPaused;
      const shouldRun = this.isConnected && this._visible && !document.hidden && !paused && this._panels.length > 1;
      this.dataset.paused = String(paused);
      this.dataset.playing = String(shouldRun);
      this._toggle.setAttribute('aria-label', paused
        ? this.dataset.playLabel || 'Animation abspielen'
        : this.dataset.pauseLabel || 'Animation pausieren');
      if (shouldRun && !this._running) {
        this._running = true;
        this._lastFrame = null;
        this._frame = requestAnimationFrame(this._tick);
      } else if (!shouldRun) {
        this._stop();
      }
    }

    _stop() {
      this._running = false;
      if (this._frame !== null) cancelAnimationFrame(this._frame);
      this._frame = null;
      this._lastFrame = null;
    }

    _tick(timestamp) {
      this._frame = null;
      if (!this._running) return;
      if (!this.isConnected || document.hidden || !this._visible) {
        this._syncPlayback();
        return;
      }
      if (this._lastFrame !== null) this._elapsed += timestamp - this._lastFrame;
      this._lastFrame = timestamp;
      if (this._elapsed >= this._interval) {
        const advances = Math.floor(this._elapsed / this._interval);
        this._elapsed %= this._interval;
        this._index = (this._index + advances) % this._panels.length;
        this._render();
      } else {
        this._updateProgress();
      }
      this._frame = requestAnimationFrame(this._tick);
    }
  }

  customElements.define('fsk-micro-focus', FskMicroFocus);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fsk-needling-page"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('fsk-needling-overview')) return;

  class FskNeedlingOverview extends HTMLElement {
    constructor() {
      super();
      this._index = 0;
      this._elapsed = 0;
      this._running = false;
      this._userPaused = false;
      this._motionPaused = false;
      this._pointerFocus = false;
      this._frame = null;
      this._lastFrame = null;
      this._tick = this._tick.bind(this);
    }

    connectedCallback() {
      if (this._controller) return;
      this._panels = Array.from(this.querySelectorAll('[data-needling-panel]'));
      this._tabs = Array.from(this.querySelectorAll('[data-needling-tab]'));
      this._counter = this.querySelector('[data-needling-current]');
      this._progress = this.querySelector('[data-needling-progress]');
      this._toggle = this.querySelector('[data-needling-toggle]');
      if (!this._panels.length || !this._toggle) return;

      this._controller = new AbortController();
      const signal = this._controller.signal;
      const requestedInterval = Number(this.dataset.interval);
      this._interval = Number.isFinite(requestedInterval) && requestedInterval >= 1000
        ? requestedInterval
        : 5000;
      this._index = Math.min(this._index, this._panels.length - 1);
      this._visible = false;
      this._mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (this._motionPreference !== this._mediaQuery.matches) {
        this._motionPaused = this._mediaQuery.matches;
      }
      this._motionPreference = this._mediaQuery.matches;

      this.addEventListener('pointerdown', () => {
        this._pointerFocus = true;
      }, { signal });

      this.addEventListener('focusin', (event) => {
        if (this._pointerFocus || this.contains(event.relatedTarget)) return;
        this._userPaused = true;
        this._syncPlayback();
      }, { signal });

      this.addEventListener('click', (event) => {
        const target = event.target instanceof Element ? event.target : null;
        const tab = target?.closest('[data-needling-tab]');
        if (tab && this.contains(tab)) {
          const index = Number(tab.dataset.index);
          if (!Number.isInteger(index) || index < 0 || index >= this._panels.length) return;
          this._select(index);
          return;
        }
        if (target?.closest('[data-needling-toggle]') !== this._toggle) return;
        if (this._userPaused || this._motionPaused) {
          this._userPaused = false;
          this._motionPaused = false;
        } else {
          this._userPaused = true;
        }
        this._syncPlayback();
      }, { signal });

      document.addEventListener('keydown', (event) => {
        this._pointerFocus = false;
        const tab = event.target instanceof Element
          ? event.target.closest('[data-needling-tab]')
          : null;
        if (!tab || !this.contains(tab)) return;
        const position = this._tabs.indexOf(tab);
        let next;
        if (event.key === 'ArrowRight') next = (position + 1) % this._tabs.length;
        if (event.key === 'ArrowLeft') next = (position - 1 + this._tabs.length) % this._tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this._tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        this._select(Number(this._tabs[next].dataset.index));
        this._tabs[next].focus();
      }, { signal, capture: true });

      document.addEventListener('visibilitychange', () => {
        this._syncPlayback();
      }, { signal });

      this._mediaQuery.addEventListener('change', (event) => {
        this._motionPreference = event.matches;
        this._motionPaused = event.matches;
        this._syncPlayback();
      }, { signal });

      document.addEventListener('shopify:section:select', (event) => {
        if (!(event.target instanceof Element) || !event.target.contains(this)) return;
        this._userPaused = true;
        this._syncPlayback();
      }, { signal });

      if ('IntersectionObserver' in window) {
        this._observer = new IntersectionObserver((entries) => {
          const entry = entries.find((item) => item.target === this);
          if (!entry) return;
          this._visible = entry.isIntersecting && entry.intersectionRatio >= .15;
          this._syncPlayback();
        }, { threshold: [0, .15] });
        this._observer.observe(this);
      } else {
        this._visible = true;
      }

      this._render();
      this.setAttribute('data-ready', '');
      this._syncPlayback();
    }

    disconnectedCallback() {
      this._stop();
      this._controller?.abort();
      this._controller = null;
      this._observer?.disconnect();
      this._observer = null;
      this._mediaQuery = null;
      this._visible = false;
      this.dataset.playing = 'false';
    }

    _select(index) {
      if (!Number.isInteger(index) || index < 0 || index >= this._panels.length) return;
      this._userPaused = true;
      this._index = index;
      this._elapsed = 0;
      this._render();
      this._syncPlayback();
    }

    _render() {
      this._panels.forEach((panel, index) => {
        const active = index === this._index;
        panel.setAttribute('aria-hidden', String(!active));
        panel.inert = !active;
      });
      this._tabs.forEach((tab) => {
        tab.setAttribute('aria-pressed', String(Number(tab.dataset.index) === this._index));
      });
      if (this._counter) this._counter.textContent = String(this._index + 1).padStart(2, '0');
      this._updateProgress();
    }

    _updateProgress() {
      this._progress?.style.setProperty('--needling-progress', String(Math.min(1, this._elapsed / this._interval)));
    }

    _syncPlayback() {
      const paused = this._userPaused || this._motionPaused;
      const shouldRun = this.isConnected && this._visible && !document.hidden && !paused && this._panels.length > 1;
      this.dataset.paused = String(paused);
      this.dataset.playing = String(shouldRun);
      this._toggle.setAttribute('aria-label', paused
        ? this.dataset.playLabel || 'Animation abspielen'
        : this.dataset.pauseLabel || 'Animation pausieren');
      if (shouldRun && !this._running) {
        this._running = true;
        this._lastFrame = null;
        this._frame = requestAnimationFrame(this._tick);
      } else if (!shouldRun) {
        this._stop();
      }
    }

    _stop() {
      this._running = false;
      if (this._frame !== null) cancelAnimationFrame(this._frame);
      this._frame = null;
      this._lastFrame = null;
    }

    _tick(timestamp) {
      this._frame = null;
      if (!this._running) return;
      if (!this.isConnected || document.hidden || !this._visible) {
        this._syncPlayback();
        return;
      }
      if (this._lastFrame !== null) this._elapsed += timestamp - this._lastFrame;
      this._lastFrame = timestamp;
      if (this._elapsed >= this._interval) {
        const advances = Math.floor(this._elapsed / this._interval);
        this._elapsed %= this._interval;
        this._index = (this._index + advances) % this._panels.length;
        this._render();
      } else {
        this._updateProgress();
      }
      this._frame = requestAnimationFrame(this._tick);
    }
  }

  customElements.define('fsk-needling-overview', FskNeedlingOverview);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fsk-oxymizer-page"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('fsk-oxy-overview')) return;

  class FskOxyOverview extends HTMLElement {
    constructor() {
      super();
      this._index = 0;
      this._elapsed = 0;
      this._running = false;
      this._userPaused = false;
      this._motionPaused = false;
      this._pointerFocus = false;
      this._frame = null;
      this._lastFrame = null;
      this._tick = this._tick.bind(this);
    }

    connectedCallback() {
      if (this._controller) return;
      this._panels = Array.from(this.querySelectorAll('[data-oxy-panel]'));
      this._tabs = Array.from(this.querySelectorAll('[data-oxy-tab]'));
      this._counter = this.querySelector('[data-oxy-current]');
      this._progress = this.querySelector('[data-oxy-progress]');
      this._toggle = this.querySelector('[data-oxy-toggle]');
      if (!this._panels.length || !this._toggle) return;

      this._controller = new AbortController();
      const signal = this._controller.signal;
      const requestedInterval = Number(this.dataset.interval);
      this._interval = Number.isFinite(requestedInterval) && requestedInterval >= 1000
        ? requestedInterval
        : 5000;
      this._index = Math.min(this._index, this._panels.length - 1);
      this._visible = false;
      this._mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (this._motionPreference !== this._mediaQuery.matches) {
        this._motionPaused = this._mediaQuery.matches;
      }
      this._motionPreference = this._mediaQuery.matches;

      this.addEventListener('pointerdown', () => {
        this._pointerFocus = true;
      }, { signal });

      this.addEventListener('focusin', (event) => {
        if (this._pointerFocus || this.contains(event.relatedTarget)) return;
        this._userPaused = true;
        this._syncPlayback();
      }, { signal });

      this.addEventListener('click', (event) => {
        const target = event.target instanceof Element ? event.target : null;
        const tab = target?.closest('[data-oxy-tab]');
        if (tab && this.contains(tab)) {
          const index = Number(tab.dataset.index);
          if (!Number.isInteger(index) || index < 0 || index >= this._panels.length) return;
          this._select(index);
          return;
        }
        if (target?.closest('[data-oxy-toggle]') !== this._toggle) return;
        if (this._userPaused || this._motionPaused) {
          this._userPaused = false;
          this._motionPaused = false;
        } else {
          this._userPaused = true;
        }
        this._syncPlayback();
      }, { signal });

      document.addEventListener('keydown', (event) => {
        this._pointerFocus = false;
        const tab = event.target instanceof Element
          ? event.target.closest('[data-oxy-tab]')
          : null;
        if (!tab || !this.contains(tab)) return;
        const position = this._tabs.indexOf(tab);
        let next;
        if (event.key === 'ArrowRight') next = (position + 1) % this._tabs.length;
        if (event.key === 'ArrowLeft') next = (position - 1 + this._tabs.length) % this._tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this._tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        this._select(Number(this._tabs[next].dataset.index));
        this._tabs[next].focus();
      }, { signal, capture: true });

      document.addEventListener('visibilitychange', () => {
        this._syncPlayback();
      }, { signal });

      this._mediaQuery.addEventListener('change', (event) => {
        this._motionPreference = event.matches;
        this._motionPaused = event.matches;
        this._syncPlayback();
      }, { signal });

      document.addEventListener('shopify:section:select', (event) => {
        if (!(event.target instanceof Element) || !event.target.contains(this)) return;
        this._userPaused = true;
        this._syncPlayback();
      }, { signal });

      if ('IntersectionObserver' in window) {
        this._observer = new IntersectionObserver((entries) => {
          const entry = entries.find((item) => item.target === this);
          if (!entry) return;
          this._visible = entry.isIntersecting && entry.intersectionRatio >= .15;
          this._syncPlayback();
        }, { threshold: [0, .15] });
        this._observer.observe(this);
      } else {
        this._visible = true;
      }

      this._render();
      this.setAttribute('data-ready', '');
      this._syncPlayback();
    }

    disconnectedCallback() {
      this._stop();
      this._controller?.abort();
      this._controller = null;
      this._observer?.disconnect();
      this._observer = null;
      this._mediaQuery = null;
      this._visible = false;
      this.dataset.playing = 'false';
    }

    _select(index) {
      if (!Number.isInteger(index) || index < 0 || index >= this._panels.length) return;
      this._userPaused = true;
      this._index = index;
      this._elapsed = 0;
      this._render();
      this._syncPlayback();
    }

    _render() {
      this._panels.forEach((panel, index) => {
        const active = index === this._index;
        panel.setAttribute('aria-hidden', String(!active));
        panel.inert = !active;
      });
      this._tabs.forEach((tab) => {
        tab.setAttribute('aria-pressed', String(Number(tab.dataset.index) === this._index));
      });
      if (this._counter) this._counter.textContent = String(this._index + 1).padStart(2, '0');
      this._updateProgress();
    }

    _updateProgress() {
      this._progress?.style.setProperty('--oxy-progress', String(Math.min(1, this._elapsed / this._interval)));
    }

    _syncPlayback() {
      const paused = this._userPaused || this._motionPaused;
      const shouldRun = this.isConnected && this._visible && !document.hidden && !paused && this._panels.length > 1;
      this.dataset.paused = String(paused);
      this.dataset.playing = String(shouldRun);
      this._toggle.setAttribute('aria-label', paused
        ? this.dataset.playLabel || 'Animation abspielen'
        : this.dataset.pauseLabel || 'Animation pausieren');
      if (shouldRun && !this._running) {
        this._running = true;
        this._lastFrame = null;
        this._frame = requestAnimationFrame(this._tick);
      } else if (!shouldRun) {
        this._stop();
      }
    }

    _stop() {
      this._running = false;
      if (this._frame !== null) cancelAnimationFrame(this._frame);
      this._frame = null;
      this._lastFrame = null;
    }

    _tick(timestamp) {
      this._frame = null;
      if (!this._running) return;
      if (!this.isConnected || document.hidden || !this._visible) {
        this._syncPlayback();
        return;
      }
      if (this._lastFrame !== null) this._elapsed += timestamp - this._lastFrame;
      this._lastFrame = timestamp;
      if (this._elapsed >= this._interval) {
        const advances = Math.floor(this._elapsed / this._interval);
        this._elapsed %= this._interval;
        this._index = (this._index + advances) % this._panels.length;
        this._render();
      } else {
        this._updateProgress();
      }
      this._frame = requestAnimationFrame(this._tick);
    }
  }

  customElements.define('fsk-oxy-overview', FskOxyOverview);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fsk-pedikuere-page"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('fsk-pedi-overview')) return;

  class FskPediOverview extends HTMLElement {
    constructor() {
      super();
      this._index = 0;
      this._elapsed = 0;
      this._running = false;
      this._userPaused = false;
      this._motionPaused = false;
      this._pointerFocus = false;
      this._frame = null;
      this._lastFrame = null;
      this._tick = this._tick.bind(this);
    }

    connectedCallback() {
      if (this._controller) return;
      this._panels = Array.from(this.querySelectorAll('[data-pedi-panel]'));
      this._tabs = Array.from(this.querySelectorAll('[data-pedi-tab]'));
      this._counter = this.querySelector('[data-pedi-current]');
      this._progress = this.querySelector('[data-pedi-progress]');
      this._toggle = this.querySelector('[data-pedi-toggle]');
      if (!this._panels.length || !this._toggle) return;

      this._controller = new AbortController();
      const signal = this._controller.signal;
      const requestedInterval = Number(this.dataset.interval);
      this._interval = Number.isFinite(requestedInterval) && requestedInterval >= 1000
        ? requestedInterval
        : 5000;
      this._index = Math.min(this._index, this._panels.length - 1);
      this._visible = false;
      this._mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (this._motionPreference !== this._mediaQuery.matches) {
        this._motionPaused = this._mediaQuery.matches;
      }
      this._motionPreference = this._mediaQuery.matches;

      this.addEventListener('pointerdown', () => {
        this._pointerFocus = true;
      }, { signal });

      this.addEventListener('focusin', (event) => {
        if (this._pointerFocus || this.contains(event.relatedTarget)) return;
        this._userPaused = true;
        this._syncPlayback();
      }, { signal });

      this.addEventListener('click', (event) => {
        const target = event.target instanceof Element ? event.target : null;
        const tab = target?.closest('[data-pedi-tab]');
        if (tab && this.contains(tab)) {
          const index = Number(tab.dataset.index);
          if (!Number.isInteger(index) || index < 0 || index >= this._panels.length) return;
          this._select(index);
          return;
        }
        if (target?.closest('[data-pedi-toggle]') !== this._toggle) return;
        if (this._userPaused || this._motionPaused) {
          this._userPaused = false;
          this._motionPaused = false;
        } else {
          this._userPaused = true;
        }
        this._syncPlayback();
      }, { signal });

      document.addEventListener('keydown', (event) => {
        this._pointerFocus = false;
        const tab = event.target instanceof Element
          ? event.target.closest('[data-pedi-tab]')
          : null;
        if (!tab || !this.contains(tab)) return;
        const position = this._tabs.indexOf(tab);
        let next;
        if (event.key === 'ArrowRight') next = (position + 1) % this._tabs.length;
        if (event.key === 'ArrowLeft') next = (position - 1 + this._tabs.length) % this._tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this._tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        this._select(Number(this._tabs[next].dataset.index));
        this._tabs[next].focus();
      }, { signal, capture: true });

      document.addEventListener('visibilitychange', () => {
        this._syncPlayback();
      }, { signal });

      this._mediaQuery.addEventListener('change', (event) => {
        this._motionPreference = event.matches;
        this._motionPaused = event.matches;
        this._syncPlayback();
      }, { signal });

      document.addEventListener('shopify:section:select', (event) => {
        if (!(event.target instanceof Element) || !event.target.contains(this)) return;
        this._userPaused = true;
        this._syncPlayback();
      }, { signal });

      if ('IntersectionObserver' in window) {
        this._observer = new IntersectionObserver((entries) => {
          const entry = entries.find((item) => item.target === this);
          if (!entry) return;
          this._visible = entry.isIntersecting && entry.intersectionRatio >= .15;
          this._syncPlayback();
        }, { threshold: [0, .15] });
        this._observer.observe(this);
      } else {
        this._visible = true;
      }

      this._render();
      this.setAttribute('data-ready', '');
      this._syncPlayback();
    }

    disconnectedCallback() {
      this._stop();
      this._controller?.abort();
      this._controller = null;
      this._observer?.disconnect();
      this._observer = null;
      this._mediaQuery = null;
      this._visible = false;
      this.dataset.playing = 'false';
    }

    _select(index) {
      if (!Number.isInteger(index) || index < 0 || index >= this._panels.length) return;
      this._userPaused = true;
      this._index = index;
      this._elapsed = 0;
      this._render();
      this._syncPlayback();
    }

    _render() {
      this._panels.forEach((panel, index) => {
        const active = index === this._index;
        panel.setAttribute('aria-hidden', String(!active));
        panel.inert = !active;
      });
      this._tabs.forEach((tab) => {
        tab.setAttribute('aria-pressed', String(Number(tab.dataset.index) === this._index));
      });
      if (this._counter) this._counter.textContent = String(this._index + 1).padStart(2, '0');
      this._updateProgress();
    }

    _updateProgress() {
      this._progress?.style.setProperty('--pedi-progress', String(Math.min(1, this._elapsed / this._interval)));
    }

    _syncPlayback() {
      const paused = this._userPaused || this._motionPaused;
      const shouldRun = this.isConnected && this._visible && !document.hidden && !paused && this._panels.length > 1;
      this.dataset.paused = String(paused);
      this.dataset.playing = String(shouldRun);
      this._toggle.setAttribute('aria-label', paused
        ? this.dataset.playLabel || 'Animation abspielen'
        : this.dataset.pauseLabel || 'Animation pausieren');
      if (shouldRun && !this._running) {
        this._running = true;
        this._lastFrame = null;
        this._frame = requestAnimationFrame(this._tick);
      } else if (!shouldRun) {
        this._stop();
      }
    }

    _stop() {
      this._running = false;
      if (this._frame !== null) cancelAnimationFrame(this._frame);
      this._frame = null;
      this._lastFrame = null;
    }

    _tick(timestamp) {
      this._frame = null;
      if (!this._running) return;
      if (!this.isConnected || document.hidden || !this._visible) {
        this._syncPlayback();
        return;
      }
      if (this._lastFrame !== null) this._elapsed += timestamp - this._lastFrame;
      this._lastFrame = timestamp;
      if (this._elapsed >= this._interval) {
        const advances = Math.floor(this._elapsed / this._interval);
        this._elapsed %= this._interval;
        this._index = (this._index + advances) % this._panels.length;
        this._render();
      } else {
        this._updateProgress();
      }
      this._frame = requestAnimationFrame(this._tick);
    }
  }

  customElements.define('fsk-pedi-overview', FskPediOverview);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fsk-plasma-page"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('fsk-plasma-overview')) return;

  class FskPlasmaOverview extends HTMLElement {
    constructor() {
      super();
      this._index = 0;
      this._elapsed = 0;
      this._running = false;
      this._userPaused = false;
      this._motionPaused = false;
      this._pointerFocus = false;
      this._frame = null;
      this._lastFrame = null;
      this._tick = this._tick.bind(this);
    }

    connectedCallback() {
      if (this._controller) return;
      this._panels = Array.from(this.querySelectorAll('[data-plasma-panel]'));
      this._tabs = Array.from(this.querySelectorAll('[data-plasma-tab]'));
      this._counter = this.querySelector('[data-plasma-current]');
      this._progress = this.querySelector('[data-plasma-progress]');
      this._toggle = this.querySelector('[data-plasma-toggle]');
      if (!this._panels.length || !this._toggle) return;

      this._controller = new AbortController();
      const signal = this._controller.signal;
      const requestedInterval = Number(this.dataset.interval);
      this._interval = Number.isFinite(requestedInterval) && requestedInterval >= 1000
        ? requestedInterval
        : 5000;
      this._index = Math.min(this._index, this._panels.length - 1);
      this._visible = false;
      this._mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (this._motionPreference !== this._mediaQuery.matches) {
        this._motionPaused = this._mediaQuery.matches;
      }
      this._motionPreference = this._mediaQuery.matches;

      this.addEventListener('pointerdown', () => {
        this._pointerFocus = true;
      }, { signal });

      this.addEventListener('focusin', (event) => {
        if (this._pointerFocus || this.contains(event.relatedTarget)) return;
        this._userPaused = true;
        this._syncPlayback();
      }, { signal });

      this.addEventListener('click', (event) => {
        const target = event.target instanceof Element ? event.target : null;
        const tab = target?.closest('[data-plasma-tab]');
        if (tab && this.contains(tab)) {
          const index = Number(tab.dataset.index);
          if (!Number.isInteger(index) || index < 0 || index >= this._panels.length) return;
          this._select(index);
          return;
        }
        if (target?.closest('[data-plasma-toggle]') !== this._toggle) return;
        if (this._userPaused || this._motionPaused) {
          this._userPaused = false;
          this._motionPaused = false;
        } else {
          this._userPaused = true;
        }
        this._syncPlayback();
      }, { signal });

      document.addEventListener('keydown', (event) => {
        this._pointerFocus = false;
        const tab = event.target instanceof Element
          ? event.target.closest('[data-plasma-tab]')
          : null;
        if (!tab || !this.contains(tab)) return;
        const position = this._tabs.indexOf(tab);
        let next;
        if (event.key === 'ArrowRight') next = (position + 1) % this._tabs.length;
        if (event.key === 'ArrowLeft') next = (position - 1 + this._tabs.length) % this._tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this._tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        this._select(Number(this._tabs[next].dataset.index));
        this._tabs[next].focus();
      }, { signal, capture: true });

      document.addEventListener('visibilitychange', () => {
        this._syncPlayback();
      }, { signal });

      this._mediaQuery.addEventListener('change', (event) => {
        this._motionPreference = event.matches;
        this._motionPaused = event.matches;
        this._syncPlayback();
      }, { signal });

      document.addEventListener('shopify:section:select', (event) => {
        if (!(event.target instanceof Element) || !event.target.contains(this)) return;
        this._userPaused = true;
        this._syncPlayback();
      }, { signal });

      if ('IntersectionObserver' in window) {
        this._observer = new IntersectionObserver((entries) => {
          const entry = entries.find((item) => item.target === this);
          if (!entry) return;
          this._visible = entry.isIntersecting && entry.intersectionRatio >= .15;
          this._syncPlayback();
        }, { threshold: [0, .15] });
        this._observer.observe(this);
      } else {
        this._visible = true;
      }

      this._render();
      this.setAttribute('data-ready', '');
      this._syncPlayback();
    }

    disconnectedCallback() {
      this._stop();
      this._controller?.abort();
      this._controller = null;
      this._observer?.disconnect();
      this._observer = null;
      this._mediaQuery = null;
      this._visible = false;
      this.dataset.playing = 'false';
    }

    _select(index) {
      if (!Number.isInteger(index) || index < 0 || index >= this._panels.length) return;
      this._userPaused = true;
      this._index = index;
      this._elapsed = 0;
      this._render();
      this._syncPlayback();
    }

    _render() {
      this._panels.forEach((panel, index) => {
        const active = index === this._index;
        panel.setAttribute('aria-hidden', String(!active));
        panel.inert = !active;
      });
      this._tabs.forEach((tab) => {
        tab.setAttribute('aria-pressed', String(Number(tab.dataset.index) === this._index));
      });
      if (this._counter) this._counter.textContent = String(this._index + 1).padStart(2, '0');
      this._updateProgress();
    }

    _updateProgress() {
      this._progress?.style.setProperty('--plasma-progress', String(Math.min(1, this._elapsed / this._interval)));
    }

    _syncPlayback() {
      const paused = this._userPaused || this._motionPaused;
      const shouldRun = this.isConnected && this._visible && !document.hidden && !paused && this._panels.length > 1;
      this.dataset.paused = String(paused);
      this.dataset.playing = String(shouldRun);
      this._toggle.setAttribute('aria-label', paused
        ? this.dataset.playLabel || 'Animation abspielen'
        : this.dataset.pauseLabel || 'Animation pausieren');
      if (shouldRun && !this._running) {
        this._running = true;
        this._lastFrame = null;
        this._frame = requestAnimationFrame(this._tick);
      } else if (!shouldRun) {
        this._stop();
      }
    }

    _stop() {
      this._running = false;
      if (this._frame !== null) cancelAnimationFrame(this._frame);
      this._frame = null;
      this._lastFrame = null;
    }

    _tick(timestamp) {
      this._frame = null;
      if (!this._running) return;
      if (!this.isConnected || document.hidden || !this._visible) {
        this._syncPlayback();
        return;
      }
      if (this._lastFrame !== null) this._elapsed += timestamp - this._lastFrame;
      this._lastFrame = timestamp;
      if (this._elapsed >= this._interval) {
        const advances = Math.floor(this._elapsed / this._interval);
        this._elapsed %= this._interval;
        this._index = (this._index + advances) % this._panels.length;
        this._render();
      } else {
        this._updateProgress();
      }
      this._frame = requestAnimationFrame(this._tick);
    }
  }

  customElements.define('fsk-plasma-overview', FskPlasmaOverview);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fsk-pmu-page"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('fsk-pmu-overview')) return;

  class FskPmuOverview extends HTMLElement {
    constructor() {
      super();
      this._index = 0;
      this._elapsed = 0;
      this._running = false;
      this._userPaused = false;
      this._motionPaused = false;
      this._pointerFocus = false;
      this._frame = null;
      this._lastFrame = null;
      this._tick = this._tick.bind(this);
    }

    connectedCallback() {
      if (this._controller) return;
      this._panels = Array.from(this.querySelectorAll('[data-pmu-panel]'));
      this._tabs = Array.from(this.querySelectorAll('[data-pmu-tab]'));
      this._counter = this.querySelector('[data-pmu-current]');
      this._progress = this.querySelector('[data-pmu-progress]');
      this._toggle = this.querySelector('[data-pmu-toggle]');
      if (!this._panels.length || !this._toggle) return;

      this._controller = new AbortController();
      const signal = this._controller.signal;
      const requestedInterval = Number(this.dataset.interval);
      this._interval = Number.isFinite(requestedInterval) && requestedInterval >= 1000
        ? requestedInterval
        : 5000;
      this._index = Math.min(this._index, this._panels.length - 1);
      this._visible = false;
      this._mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (this._motionPreference !== this._mediaQuery.matches) {
        this._motionPaused = this._mediaQuery.matches;
      }
      this._motionPreference = this._mediaQuery.matches;

      this.addEventListener('pointerdown', () => {
        this._pointerFocus = true;
      }, { signal });

      this.addEventListener('focusin', (event) => {
        if (this._pointerFocus || this.contains(event.relatedTarget)) return;
        this._userPaused = true;
        this._syncPlayback();
      }, { signal });

      this.addEventListener('click', (event) => {
        const target = event.target instanceof Element ? event.target : null;
        const tab = target?.closest('[data-pmu-tab]');
        if (tab && this.contains(tab)) {
          const index = Number(tab.dataset.index);
          if (!Number.isInteger(index) || index < 0 || index >= this._panels.length) return;
          this._select(index);
          return;
        }
        if (target?.closest('[data-pmu-toggle]') !== this._toggle) return;
        if (this._userPaused || this._motionPaused) {
          this._userPaused = false;
          this._motionPaused = false;
        } else {
          this._userPaused = true;
        }
        this._syncPlayback();
      }, { signal });

      document.addEventListener('keydown', (event) => {
        this._pointerFocus = false;
        const tab = event.target instanceof Element
          ? event.target.closest('[data-pmu-tab]')
          : null;
        if (!tab || !this.contains(tab)) return;
        const position = this._tabs.indexOf(tab);
        let next;
        if (event.key === 'ArrowRight') next = (position + 1) % this._tabs.length;
        if (event.key === 'ArrowLeft') next = (position - 1 + this._tabs.length) % this._tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this._tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        this._select(Number(this._tabs[next].dataset.index));
        this._tabs[next].focus();
      }, { signal, capture: true });

      document.addEventListener('visibilitychange', () => {
        this._syncPlayback();
      }, { signal });

      this._mediaQuery.addEventListener('change', (event) => {
        this._motionPreference = event.matches;
        this._motionPaused = event.matches;
        this._syncPlayback();
      }, { signal });

      document.addEventListener('shopify:section:select', (event) => {
        if (!(event.target instanceof Element) || !event.target.contains(this)) return;
        this._userPaused = true;
        this._syncPlayback();
      }, { signal });

      if ('IntersectionObserver' in window) {
        this._observer = new IntersectionObserver((entries) => {
          const entry = entries.find((item) => item.target === this);
          if (!entry) return;
          this._visible = entry.isIntersecting && entry.intersectionRatio >= .15;
          this._syncPlayback();
        }, { threshold: [0, .15] });
        this._observer.observe(this);
      } else {
        this._visible = true;
      }

      this._render();
      this.setAttribute('data-ready', '');
      this._syncPlayback();
    }

    disconnectedCallback() {
      this._stop();
      this._controller?.abort();
      this._controller = null;
      this._observer?.disconnect();
      this._observer = null;
      this._mediaQuery = null;
      this._visible = false;
      this.dataset.playing = 'false';
    }

    _select(index) {
      if (!Number.isInteger(index) || index < 0 || index >= this._panels.length) return;
      this._userPaused = true;
      this._index = index;
      this._elapsed = 0;
      this._render();
      this._syncPlayback();
    }

    _render() {
      this._panels.forEach((panel, index) => {
        const active = index === this._index;
        panel.setAttribute('aria-hidden', String(!active));
        panel.inert = !active;
      });
      this._tabs.forEach((tab) => {
        tab.setAttribute('aria-pressed', String(Number(tab.dataset.index) === this._index));
      });
      if (this._counter) this._counter.textContent = String(this._index + 1).padStart(2, '0');
      this._updateProgress();
    }

    _updateProgress() {
      this._progress?.style.setProperty('--pmu-progress', String(Math.min(1, this._elapsed / this._interval)));
    }

    _syncPlayback() {
      const paused = this._userPaused || this._motionPaused;
      const shouldRun = this.isConnected && this._visible && !document.hidden && !paused && this._panels.length > 1;
      this.dataset.paused = String(paused);
      this.dataset.playing = String(shouldRun);
      this._toggle.setAttribute('aria-label', paused
        ? this.dataset.playLabel || 'Animation abspielen'
        : this.dataset.pauseLabel || 'Animation pausieren');
      if (shouldRun && !this._running) {
        this._running = true;
        this._lastFrame = null;
        this._frame = requestAnimationFrame(this._tick);
      } else if (!shouldRun) {
        this._stop();
      }
    }

    _stop() {
      this._running = false;
      if (this._frame !== null) cancelAnimationFrame(this._frame);
      this._frame = null;
      this._lastFrame = null;
    }

    _tick(timestamp) {
      this._frame = null;
      if (!this._running) return;
      if (!this.isConnected || document.hidden || !this._visible) {
        this._syncPlayback();
        return;
      }
      if (this._lastFrame !== null) this._elapsed += timestamp - this._lastFrame;
      this._lastFrame = timestamp;
      if (this._elapsed >= this._interval) {
        const advances = Math.floor(this._elapsed / this._interval);
        this._elapsed %= this._interval;
        this._index = (this._index + advances) % this._panels.length;
        this._render();
      } else {
        this._updateProgress();
      }
      this._frame = requestAnimationFrame(this._tick);
    }
  }

  customElements.define('fsk-pmu-overview', FskPmuOverview);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fsk-po-behandlung-page"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('fsk-po-overview')) return;

  class FskPoOverview extends HTMLElement {
    constructor() {
      super();
      this._index = 0;
      this._elapsed = 0;
      this._running = false;
      this._userPaused = false;
      this._motionPaused = false;
      this._pointerFocus = false;
      this._frame = null;
      this._lastFrame = null;
      this._tick = this._tick.bind(this);
    }

    connectedCallback() {
      if (this._controller) return;
      this._panels = Array.from(this.querySelectorAll('[data-po-panel]'));
      this._tabs = Array.from(this.querySelectorAll('[data-po-tab]'));
      this._counter = this.querySelector('[data-po-current]');
      this._progress = this.querySelector('[data-po-progress]');
      this._toggle = this.querySelector('[data-po-toggle]');
      if (!this._panels.length || !this._toggle) return;

      this._controller = new AbortController();
      const signal = this._controller.signal;
      const requestedInterval = Number(this.dataset.interval);
      this._interval = Number.isFinite(requestedInterval) && requestedInterval >= 1000
        ? requestedInterval
        : 5000;
      this._index = Math.min(this._index, this._panels.length - 1);
      this._visible = false;
      this._mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (this._motionPreference !== this._mediaQuery.matches) {
        this._motionPaused = this._mediaQuery.matches;
      }
      this._motionPreference = this._mediaQuery.matches;

      this.addEventListener('pointerdown', () => {
        this._pointerFocus = true;
      }, { signal });

      this.addEventListener('focusin', (event) => {
        if (this._pointerFocus || this.contains(event.relatedTarget)) return;
        this._userPaused = true;
        this._syncPlayback();
      }, { signal });

      this.addEventListener('click', (event) => {
        const target = event.target instanceof Element ? event.target : null;
        const tab = target?.closest('[data-po-tab]');
        if (tab && this.contains(tab)) {
          const index = Number(tab.dataset.index);
          if (!Number.isInteger(index) || index < 0 || index >= this._panels.length) return;
          this._select(index);
          return;
        }
        if (target?.closest('[data-po-toggle]') !== this._toggle) return;
        if (this._userPaused || this._motionPaused) {
          this._userPaused = false;
          this._motionPaused = false;
        } else {
          this._userPaused = true;
        }
        this._syncPlayback();
      }, { signal });

      document.addEventListener('keydown', (event) => {
        this._pointerFocus = false;
        const tab = event.target instanceof Element
          ? event.target.closest('[data-po-tab]')
          : null;
        if (!tab || !this.contains(tab)) return;
        const position = this._tabs.indexOf(tab);
        let next;
        if (event.key === 'ArrowRight') next = (position + 1) % this._tabs.length;
        if (event.key === 'ArrowLeft') next = (position - 1 + this._tabs.length) % this._tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this._tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        this._select(Number(this._tabs[next].dataset.index));
        this._tabs[next].focus();
      }, { signal, capture: true });

      document.addEventListener('visibilitychange', () => {
        this._syncPlayback();
      }, { signal });

      this._mediaQuery.addEventListener('change', (event) => {
        this._motionPreference = event.matches;
        this._motionPaused = event.matches;
        this._syncPlayback();
      }, { signal });

      document.addEventListener('shopify:section:select', (event) => {
        if (!(event.target instanceof Element) || !event.target.contains(this)) return;
        this._userPaused = true;
        this._syncPlayback();
      }, { signal });

      if ('IntersectionObserver' in window) {
        this._observer = new IntersectionObserver((entries) => {
          const entry = entries.find((item) => item.target === this);
          if (!entry) return;
          this._visible = entry.isIntersecting && entry.intersectionRatio >= .15;
          this._syncPlayback();
        }, { threshold: [0, .15] });
        this._observer.observe(this);
      } else {
        this._visible = true;
      }

      this._render();
      this.setAttribute('data-ready', '');
      this._syncPlayback();
    }

    disconnectedCallback() {
      this._stop();
      this._controller?.abort();
      this._controller = null;
      this._observer?.disconnect();
      this._observer = null;
      this._mediaQuery = null;
      this._visible = false;
      this.dataset.playing = 'false';
    }

    _select(index) {
      if (!Number.isInteger(index) || index < 0 || index >= this._panels.length) return;
      this._userPaused = true;
      this._index = index;
      this._elapsed = 0;
      this._render();
      this._syncPlayback();
    }

    _render() {
      this._panels.forEach((panel, index) => {
        const active = index === this._index;
        panel.setAttribute('aria-hidden', String(!active));
        panel.inert = !active;
      });
      this._tabs.forEach((tab) => {
        tab.setAttribute('aria-pressed', String(Number(tab.dataset.index) === this._index));
      });
      if (this._counter) this._counter.textContent = String(this._index + 1).padStart(2, '0');
      this._updateProgress();
    }

    _updateProgress() {
      this._progress?.style.setProperty('--po-progress', String(Math.min(1, this._elapsed / this._interval)));
    }

    _syncPlayback() {
      const paused = this._userPaused || this._motionPaused;
      const shouldRun = this.isConnected && this._visible && !document.hidden && !paused && this._panels.length > 1;
      this.dataset.paused = String(paused);
      this.dataset.playing = String(shouldRun);
      this._toggle.setAttribute('aria-label', paused
        ? this.dataset.playLabel || 'Animation abspielen'
        : this.dataset.pauseLabel || 'Animation pausieren');
      if (shouldRun && !this._running) {
        this._running = true;
        this._lastFrame = null;
        this._frame = requestAnimationFrame(this._tick);
      } else if (!shouldRun) {
        this._stop();
      }
    }

    _stop() {
      this._running = false;
      if (this._frame !== null) cancelAnimationFrame(this._frame);
      this._frame = null;
      this._lastFrame = null;
    }

    _tick(timestamp) {
      this._frame = null;
      if (!this._running) return;
      if (!this.isConnected || document.hidden || !this._visible) {
        this._syncPlayback();
        return;
      }
      if (this._lastFrame !== null) this._elapsed += timestamp - this._lastFrame;
      this._lastFrame = timestamp;
      if (this._elapsed >= this._interval) {
        const advances = Math.floor(this._elapsed / this._interval);
        this._elapsed %= this._interval;
        this._index = (this._index + advances) % this._panels.length;
        this._render();
      } else {
        this._updateProgress();
      }
      this._frame = requestAnimationFrame(this._tick);
    }
  }

  customElements.define('fsk-po-overview', FskPoOverview);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fsk-radiofrequenz-page"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('fsk-radio-overview')) return;

  class FskRadioOverview extends HTMLElement {
    constructor() {
      super();
      this._index = 0;
      this._elapsed = 0;
      this._running = false;
      this._userPaused = false;
      this._motionPaused = false;
      this._pointerFocus = false;
      this._frame = null;
      this._lastFrame = null;
      this._tick = this._tick.bind(this);
    }

    connectedCallback() {
      if (this._controller) return;
      this._panels = Array.from(this.querySelectorAll('[data-radio-panel]'));
      this._tabs = Array.from(this.querySelectorAll('[data-radio-tab]'));
      this._counter = this.querySelector('[data-radio-current]');
      this._progress = this.querySelector('[data-radio-progress]');
      this._toggle = this.querySelector('[data-radio-toggle]');
      if (!this._panels.length || !this._toggle) return;

      this._controller = new AbortController();
      const signal = this._controller.signal;
      const requestedInterval = Number(this.dataset.interval);
      this._interval = Number.isFinite(requestedInterval) && requestedInterval >= 1000
        ? requestedInterval
        : 5000;
      this._index = Math.min(this._index, this._panels.length - 1);
      this._visible = false;
      this._mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (this._motionPreference !== this._mediaQuery.matches) {
        this._motionPaused = this._mediaQuery.matches;
      }
      this._motionPreference = this._mediaQuery.matches;

      this.addEventListener('pointerdown', () => {
        this._pointerFocus = true;
      }, { signal });

      this.addEventListener('focusin', (event) => {
        if (this._pointerFocus || this.contains(event.relatedTarget)) return;
        this._userPaused = true;
        this._syncPlayback();
      }, { signal });

      this.addEventListener('click', (event) => {
        const target = event.target instanceof Element ? event.target : null;
        const tab = target?.closest('[data-radio-tab]');
        if (tab && this.contains(tab)) {
          const index = Number(tab.dataset.index);
          if (!Number.isInteger(index) || index < 0 || index >= this._panels.length) return;
          this._select(index);
          return;
        }
        if (target?.closest('[data-radio-toggle]') !== this._toggle) return;
        if (this._userPaused || this._motionPaused) {
          this._userPaused = false;
          this._motionPaused = false;
        } else {
          this._userPaused = true;
        }
        this._syncPlayback();
      }, { signal });

      document.addEventListener('keydown', (event) => {
        this._pointerFocus = false;
        const tab = event.target instanceof Element
          ? event.target.closest('[data-radio-tab]')
          : null;
        if (!tab || !this.contains(tab)) return;
        const position = this._tabs.indexOf(tab);
        let next;
        if (event.key === 'ArrowRight') next = (position + 1) % this._tabs.length;
        if (event.key === 'ArrowLeft') next = (position - 1 + this._tabs.length) % this._tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this._tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        this._select(Number(this._tabs[next].dataset.index));
        this._tabs[next].focus();
      }, { signal, capture: true });

      document.addEventListener('visibilitychange', () => {
        this._syncPlayback();
      }, { signal });

      this._mediaQuery.addEventListener('change', (event) => {
        this._motionPreference = event.matches;
        this._motionPaused = event.matches;
        this._syncPlayback();
      }, { signal });

      document.addEventListener('shopify:section:select', (event) => {
        if (!(event.target instanceof Element) || !event.target.contains(this)) return;
        this._userPaused = true;
        this._syncPlayback();
      }, { signal });

      if ('IntersectionObserver' in window) {
        this._observer = new IntersectionObserver((entries) => {
          const entry = entries.find((item) => item.target === this);
          if (!entry) return;
          this._visible = entry.isIntersecting && entry.intersectionRatio >= .15;
          this._syncPlayback();
        }, { threshold: [0, .15] });
        this._observer.observe(this);
      } else {
        this._visible = true;
      }

      this._render();
      this.setAttribute('data-ready', '');
      this._syncPlayback();
    }

    disconnectedCallback() {
      this._stop();
      this._controller?.abort();
      this._controller = null;
      this._observer?.disconnect();
      this._observer = null;
      this._mediaQuery = null;
      this._visible = false;
      this.dataset.playing = 'false';
    }

    _select(index) {
      if (!Number.isInteger(index) || index < 0 || index >= this._panels.length) return;
      this._userPaused = true;
      this._index = index;
      this._elapsed = 0;
      this._render();
      this._syncPlayback();
    }

    _render() {
      this._panels.forEach((panel, index) => {
        const active = index === this._index;
        panel.setAttribute('aria-hidden', String(!active));
        panel.inert = !active;
      });
      this._tabs.forEach((tab) => {
        tab.setAttribute('aria-pressed', String(Number(tab.dataset.index) === this._index));
      });
      if (this._counter) this._counter.textContent = String(this._index + 1).padStart(2, '0');
      this._updateProgress();
    }

    _updateProgress() {
      this._progress?.style.setProperty('--radio-progress', String(Math.min(1, this._elapsed / this._interval)));
    }

    _syncPlayback() {
      const paused = this._userPaused || this._motionPaused;
      const shouldRun = this.isConnected && this._visible && !document.hidden && !paused && this._panels.length > 1;
      this.dataset.paused = String(paused);
      this.dataset.playing = String(shouldRun);
      this._toggle.setAttribute('aria-label', paused
        ? this.dataset.playLabel || 'Animation abspielen'
        : this.dataset.pauseLabel || 'Animation pausieren');
      if (shouldRun && !this._running) {
        this._running = true;
        this._lastFrame = null;
        this._frame = requestAnimationFrame(this._tick);
      } else if (!shouldRun) {
        this._stop();
      }
    }

    _stop() {
      this._running = false;
      if (this._frame !== null) cancelAnimationFrame(this._frame);
      this._frame = null;
      this._lastFrame = null;
    }

    _tick(timestamp) {
      this._frame = null;
      if (!this._running) return;
      if (!this.isConnected || document.hidden || !this._visible) {
        this._syncPlayback();
        return;
      }
      if (this._lastFrame !== null) this._elapsed += timestamp - this._lastFrame;
      this._lastFrame = timestamp;
      if (this._elapsed >= this._interval) {
        const advances = Math.floor(this._elapsed / this._interval);
        this._elapsed %= this._interval;
        this._index = (this._index + advances) % this._panels.length;
        this._render();
      } else {
        this._updateProgress();
      }
      this._frame = requestAnimationFrame(this._tick);
    }
  }

  customElements.define('fsk-radio-overview', FskRadioOverview);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fsk-skin-path"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fsk-skin-explorer')) {
    customElements.define('fsk-skin-explorer', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.tabs = [...this.querySelectorAll('[data-skin-tab]')];
        this.panels = [...this.querySelectorAll('[data-skin-panel]')];
        this.tablist = this.querySelector('[data-skin-tabs]');
        if (!this.tabs.length || !this.tablist) return;
        this.tablist.setAttribute('role', 'tablist');
        this.tablist.setAttribute('aria-labelledby', this.querySelector('h2').id);
        this.tabs.forEach((tab) => {
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-controls', tab.dataset.skinPanelId);
        });
        this.panels.forEach((panel) => panel.setAttribute('role', 'tabpanel'));
        this.activate(this.tabs[0], false);
        const options = { signal: this.controller.signal };
        this.tablist.addEventListener('click', (event) => {
          const tab = event.target.closest('[data-skin-tab]');
          if (!tab || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
          event.preventDefault();
          this.activate(tab, true);
        }, options);
        this.tablist.addEventListener('keydown', (event) => {
          const tab = event.target.closest('[data-skin-tab]');
          if (!tab) return;
          const index = this.tabs.indexOf(tab);
          let next = index;
          if (['ArrowRight', 'ArrowDown'].includes(event.key)) next = (index + 1) % this.tabs.length;
          else if (['ArrowLeft', 'ArrowUp'].includes(event.key)) next = (index - 1 + this.tabs.length) % this.tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = this.tabs.length - 1;
          else if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          this.activate(this.tabs[next], true);
          this.tabs[next].focus({ preventScroll: true });
        }, options);
        this.tablist.addEventListener('pointerover', (event) => {
          const tab = event.target.closest('[data-skin-tab]');
          if (tab) this.warmImages(tab);
        }, options);
        this.addEventListener('shopify:block:select', (event) => {
          const tab = event.target.querySelector('[data-skin-tab]');
          if (tab) this.activate(tab, false);
        }, options);
      }
      warmImages(tab) {
        this.panels.find((panel) => panel.id === tab.dataset.skinPanelId)?.querySelectorAll('img').forEach((image) => {
          image.loading = 'eager';
        });
      }
      activate(tab, animate) {
        if (this.activeTab === tab) return;
        this.animation?.cancel();
        this.activeTab = tab;
        this.tabs.forEach((item) => {
          const selected = item === tab;
          item.classList.toggle('is-active', selected);
          item.setAttribute('aria-selected', String(selected));
          item.tabIndex = selected ? 0 : -1;
        });
        let activePanel;
        this.panels.forEach((panel) => {
          panel.hidden = panel.id !== tab.dataset.skinPanelId;
          if (!panel.hidden) activePanel = panel;
        });
        if (animate) this.warmImages(tab);
        if (window.matchMedia('(max-width: 749px)').matches) {
          this.tablist.scrollTo({
            left: tab.offsetLeft - (this.tablist.clientWidth - tab.offsetWidth) / 2,
            behavior: animate && !window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'auto'
          });
        }
        if (animate && activePanel && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.animation = activePanel.animate(
            [{ opacity: .2, transform: 'translateY(5px)' }, { opacity: 1, transform: 'translateY(0)' }],
            { duration: 230, easing: 'ease-out' }
          );
        }
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.animation?.cancel();
        this.activeTab = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fsk-studio-page"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('fsk-studio-reveal')) {
  customElements.define('fsk-studio-reveal', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.animations = new Set();
      const cancelMotion = () => {
        this.observer?.disconnect();
        this.animations.forEach(animation => animation.cancel());
        this.animations.clear();
      };
      const start = () => {
        if (this.motion.matches || !('IntersectionObserver' in window) || !Element.prototype.animate) return;
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            this.observer.unobserve(entry.target);
            if (entry.target.contains(document.activeElement) || this.motion.matches) return;
            const delay = parseFloat(getComputedStyle(entry.target).getPropertyValue('--studio-delay')) || 0;
            const animation = entry.target.animate([
              { opacity: 0, transform: 'translateY(28px)' },
              { opacity: 1, transform: 'translateY(0)' }
            ], { duration: 1250, delay, easing: 'cubic-bezier(.25,.46,.45,.94)', fill: 'backwards' });
            this.animations.add(animation);
            const done = () => this.animations.delete(animation);
            animation.addEventListener('finish', done, {once:true});
            animation.addEventListener('cancel', done, {once:true});
            entry.target.dataset.studioRevealed = 'true';
          });
        }, {threshold:.08, rootMargin:'0px 0px -24px 0px'});
        this.querySelectorAll('[data-studio-reveal]').forEach(element => this.observer.observe(element));
      };
      this.addEventListener('focusin', event => {
        const region = event.target.closest('[data-studio-reveal]');
        if (region) {
          this.observer?.unobserve(region);
          region.getAnimations().forEach(animation => animation.cancel());
        }
      }, {signal:this.controller.signal});
      this.motion.addEventListener('change', cancelMotion, {signal:this.controller.signal});
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', start, {once:true,signal:this.controller.signal});
      } else start();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.animations?.forEach(animation => animation.cancel());
      this.animations?.clear();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fsk-studios-overview"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('fsk-studio-reveal')) {
  customElements.define('fsk-studio-reveal', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.animations = new Set();
      const cancelMotion = () => {
        this.observer?.disconnect();
        this.animations.forEach(animation => animation.cancel());
        this.animations.clear();
      };
      const start = () => {
        if (this.motion.matches || !('IntersectionObserver' in window) || !Element.prototype.animate) return;
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            this.observer.unobserve(entry.target);
            if (entry.target.contains(document.activeElement) || this.motion.matches) return;
            const delay = parseFloat(getComputedStyle(entry.target).getPropertyValue('--studio-delay')) || 0;
            const animation = entry.target.animate([
              { opacity: 0, transform: 'translateY(28px)' },
              { opacity: 1, transform: 'translateY(0)' }
            ], { duration: 1250, delay, easing: 'cubic-bezier(.25,.46,.45,.94)', fill: 'backwards' });
            this.animations.add(animation);
            const done = () => this.animations.delete(animation);
            animation.addEventListener('finish', done, {once:true});
            animation.addEventListener('cancel', done, {once:true});
            entry.target.dataset.studioRevealed = 'true';
          });
        }, {threshold:.08, rootMargin:'0px 0px -24px 0px'});
        this.querySelectorAll('[data-studio-reveal]').forEach(element => this.observer.observe(element));
      };
      this.addEventListener('focusin', event => {
        const region = event.target.closest('[data-studio-reveal]');
        if (region) {
          this.observer?.unobserve(region);
          region.getAnimations().forEach(animation => animation.cancel());
        }
      }, {signal:this.controller.signal});
      this.motion.addEventListener('change', cancelMotion, {signal:this.controller.signal});
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', start, {once:true,signal:this.controller.signal});
      } else start();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.animations?.forEach(animation => animation.cancel());
      this.animations?.clear();
    }
  });
}
(() => {
  if (customElements.get('fsk-studio-focus')) return;

  class FskStudioFocus extends HTMLElement {
    constructor() {
      super();
      this._index = 0;
      this._elapsed = 0;
      this._running = false;
      this._userPaused = false;
      this._motionPaused = false;
      this._pointerFocus = false;
      this._frame = null;
      this._lastFrame = null;
      this._tick = this._tick.bind(this);
    }

    connectedCallback() {
      if (this._controller) return;
      this._panels = Array.from(this.querySelectorAll('[data-studio-focus-panel]'));
      this._tabs = Array.from(this.querySelectorAll('[data-studio-focus-tab]'));
      this._counter = this.querySelector('[data-studio-focus-current]');
      this._progress = this.querySelector('[data-studio-focus-progress]');
      this._toggle = this.querySelector('[data-studio-focus-toggle]');
      if (!this._panels.length || !this._toggle) return;

      this._controller = new AbortController();
      const signal = this._controller.signal;
      const requestedInterval = Number(this.dataset.interval);
      this._interval = Number.isFinite(requestedInterval) && requestedInterval >= 1000
        ? requestedInterval
        : 5000;
      this._index = Math.min(this._index, this._panels.length - 1);
      this._visible = false;
      this._hoverPaused = false;
      this._mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (this._motionPreference !== this._mediaQuery.matches) {
        this._motionPaused = this._mediaQuery.matches;
      }
      this._motionPreference = this._mediaQuery.matches;

      this.addEventListener('pointerenter', event => {
        if (event.pointerType !== 'mouse') return;
        this._hoverPaused = true;
        this._syncPlayback();
      }, { signal });
      this.addEventListener('pointerleave', () => {
        this._hoverPaused = false;
        this._syncPlayback();
      }, { signal });

      this.addEventListener('pointerdown', () => {
        this._pointerFocus = true;
      }, { signal });

      this.addEventListener('focusin', (event) => {
        if (this._pointerFocus || this.contains(event.relatedTarget)) return;
        this._userPaused = true;
        this._syncPlayback();
      }, { signal });

      this.addEventListener('click', (event) => {
        const target = event.target instanceof Element ? event.target : null;
        const tab = target?.closest('[data-studio-focus-tab]');
        if (tab && this.contains(tab)) {
          const index = Number(tab.dataset.index);
          if (!Number.isInteger(index) || index < 0 || index >= this._panels.length) return;
          this._select(index);
          return;
        }
        if (target?.closest('[data-studio-focus-toggle]') !== this._toggle) return;
        if (this._userPaused || this._motionPaused) {
          this._userPaused = false;
          this._motionPaused = false;
        } else {
          this._userPaused = true;
        }
        this._syncPlayback();
      }, { signal });

      document.addEventListener('keydown', (event) => {
        this._pointerFocus = false;
        const tab = event.target instanceof Element
          ? event.target.closest('[data-studio-focus-tab]')
          : null;
        if (!tab || !this.contains(tab)) return;
        const position = this._tabs.indexOf(tab);
        let next;
        if (event.key === 'ArrowRight') next = (position + 1) % this._tabs.length;
        if (event.key === 'ArrowLeft') next = (position - 1 + this._tabs.length) % this._tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this._tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        this._select(Number(this._tabs[next].dataset.index));
        this._tabs[next].focus();
      }, { signal, capture: true });

      document.addEventListener('visibilitychange', () => {
        this._syncPlayback();
      }, { signal });

      this._mediaQuery.addEventListener('change', (event) => {
        this._motionPreference = event.matches;
        this._motionPaused = event.matches;
        this._syncPlayback();
      }, { signal });

      document.addEventListener('shopify:section:select', (event) => {
        if (!(event.target instanceof Element) || !event.target.contains(this)) return;
        this._userPaused = true;
        this._syncPlayback();
      }, { signal });

      if ('IntersectionObserver' in window) {
        this._observer = new IntersectionObserver((entries) => {
          const entry = entries.find((item) => item.target === this);
          if (!entry) return;
          this._visible = entry.isIntersecting && entry.intersectionRatio >= .15;
          this._syncPlayback();
        }, { threshold: [0, .15] });
        this._observer.observe(this);
      } else {
        this._visible = true;
      }

      this._render();
      this.setAttribute('data-ready', '');
      this._syncPlayback();
    }

    disconnectedCallback() {
      this._stop();
      this._controller?.abort();
      this._controller = null;
      this._observer?.disconnect();
      this._observer = null;
      this._mediaQuery = null;
      this._visible = false;
      this.dataset.playing = 'false';
    }

    _select(index) {
      if (!Number.isInteger(index) || index < 0 || index >= this._panels.length) return;
      this._userPaused = true;
      this._index = index;
      this._elapsed = 0;
      this._render();
      this._syncPlayback();
    }

    _render() {
      this._panels.forEach((panel, index) => {
        const active = index === this._index;
        panel.setAttribute('aria-hidden', String(!active));
        panel.inert = !active;
      });
      this._tabs.forEach((tab) => {
        tab.setAttribute('aria-pressed', String(Number(tab.dataset.index) === this._index));
      });
      this.querySelectorAll('[data-studio-focus-node]').forEach(node => {
        node.classList.toggle('is-active', Number(node.dataset.studioFocusNode) === this._index);
      });
      if (this._counter) this._counter.textContent = String(this._index + 1).padStart(2, '0');
      this._updateProgress();
    }

    _updateProgress() {
      this._progress?.style.setProperty('--studio-progress', String(Math.min(1, this._elapsed / this._interval)));
    }

    _syncPlayback() {
      const paused = this._userPaused || this._motionPaused;
      const shouldRun = this.isConnected && this._visible && !document.hidden && !paused && !this._hoverPaused && this._panels.length > 1;
      this.dataset.paused = String(paused);
      this.dataset.playing = String(shouldRun);
      this._toggle.setAttribute('aria-label', paused
        ? this.dataset.playLabel || 'Animation abspielen'
        : this.dataset.pauseLabel || 'Animation pausieren');
      if (shouldRun && !this._running) {
        this._running = true;
        this._lastFrame = null;
        this._frame = requestAnimationFrame(this._tick);
      } else if (!shouldRun) {
        this._stop();
      }
    }

    _stop() {
      this._running = false;
      if (this._frame !== null) cancelAnimationFrame(this._frame);
      this._frame = null;
      this._lastFrame = null;
    }

    _tick(timestamp) {
      this._frame = null;
      if (!this._running) return;
      if (!this.isConnected || document.hidden || !this._visible) {
        this._syncPlayback();
        return;
      }
      if (this._lastFrame !== null) this._elapsed += timestamp - this._lastFrame;
      this._lastFrame = timestamp;
      if (this._elapsed >= this._interval) {
        const advances = Math.floor(this._elapsed / this._interval);
        this._elapsed %= this._interval;
        this._index = (this._index + advances) % this._panels.length;
        this._render();
      } else {
        this._updateProgress();
      }
      this._frame = requestAnimationFrame(this._tick);
    }
  }

  customElements.define('fsk-studio-focus', FskStudioFocus);
})();



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fsk-treatment-guide"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fsk-home-treatment-guide')) {
    customElements.define('fsk-home-treatment-guide', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.items = Array.from(this.querySelectorAll('[data-treatment-item]'));
        this.buttons = Array.from(this.querySelectorAll('[data-treatment-filter]'));
        this.status = this.querySelector('[data-treatment-status]');
        this.mobile = window.matchMedia('(max-width: 749px)');
        this.mobileStates = new Map();
        this.activeFilter = 'all';
        this.handleBreakpoint = () => this.syncDetails();
        this.handleFilter = (event) => {
          const button = event.target.closest('[data-treatment-filter]');
          if (button && this.contains(button)) this.filter(button.dataset.treatmentFilter);
        };
        this.handleToggle = (event) => {
          if (this.mobile.matches && event.target.matches('.fsk-treatments__details')) {
            this.mobileStates.set(event.target, event.target.open);
          }
        };
        this.handleBlockSelect = (event) => {
          const item = this.items.find((candidate) => candidate.dataset.blockId === event.detail?.blockId);
          if (!item) return;
          this.filter('all');
          const details = item.querySelector('details');
          details.open = true;
          this.mobileStates.set(details, true);
        };
        this.addEventListener('click', this.handleFilter);
        this.addEventListener('toggle', this.handleToggle, true);
        this.mobile.addEventListener('change', this.handleBreakpoint);
        document.addEventListener('shopify:block:select', this.handleBlockSelect);
        this.syncDetails();
        const filters = this.querySelector('[data-treatment-filters]');
        if (filters) filters.hidden = false;
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.handleFilter);
        this.removeEventListener('toggle', this.handleToggle, true);
        this.mobile?.removeEventListener('change', this.handleBreakpoint);
        document.removeEventListener('shopify:block:select', this.handleBlockSelect);
        this.initialized = false;
      }
      syncDetails() {
        this.items.forEach((item) => {
          const details = item.querySelector('details');
          details.open = this.mobile.matches ? this.mobileStates.get(details) === true : true;
        });
      }
      filter(category) {
        let visible = 0;
        this.activeFilter = category;
        this.items.forEach((item) => {
          const matches = category === 'all' || item.dataset.categories.split(/\s+/).includes(category);
          item.hidden = !matches;
          if (matches) visible += 1;
        });
        this.buttons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.treatmentFilter === category)));
        if (this.status) this.status.textContent = this.dataset.resultTemplate.replace('__COUNT__', String(visible));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fsk-treatment-story"]) return;
  try {
    
if (!customElements.get('fsk-care-story')) {
  customElements.define('fsk-care-story', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.animations = new Set();
      const cancelMotion = () => {
        this.observer?.disconnect();
        this.animations.forEach(animation => animation.cancel());
        this.animations.clear();
      };
      const start = () => {
        this.setupPersonalTile();
        if (this.motion.matches || !('IntersectionObserver' in window) || !Element.prototype.animate) return;
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            this.observer.unobserve(entry.target);
            if (entry.target.contains(document.activeElement) || this.motion.matches) return;
            const delay = parseFloat(getComputedStyle(entry.target).getPropertyValue('--micro-delay')) || 0;
            const animation = entry.target.animate([
              { opacity: 0, transform: 'translateY(28px)' },
              { opacity: 1, transform: 'translateY(0)' }
            ], { duration: 1250, delay, easing: 'cubic-bezier(.25,.46,.45,.94)', fill: 'backwards' });
            this.animations.add(animation);
            const done = () => this.animations.delete(animation);
            animation.addEventListener('finish', done, {once:true});
            animation.addEventListener('cancel', done, {once:true});
            entry.target.dataset.microRevealed = 'true';
          });
        }, {threshold:.08, rootMargin:'0px 0px -24px 0px'});
        this.querySelectorAll('[data-micro-reveal]').forEach(element => this.observer.observe(element));
      };
      this.addEventListener('focusin', event => {
        const region = event.target.closest('[data-micro-reveal]');
        if (region) {
          this.observer?.unobserve(region);
          region.getAnimations().forEach(animation => animation.cancel());
        }
      }, {signal:this.controller.signal});
      this.motion.addEventListener('change', cancelMotion, {signal:this.controller.signal});
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', start, {once:true,signal:this.controller.signal});
      } else start();
    }
    setupPersonalTile() {
      const photo = this.querySelector('.fsk-care__personal-photo');
      const copy = this.querySelector('.fsk-care__personal-copy');
      if (!photo || !copy) return;
      const signal = this.controller.signal;
      const desktop = window.matchMedia('(min-width: 750px)');
      let lastHeight = 0;
      const measure = () => {
        this.personalFrame = null;
        if (signal.aborted || !this.isConnected || !desktop.matches) return;
        let height = copy.getBoundingClientRect().height;
        if (!height || !copy.getBoundingClientRect().width) return;
        // Match the closed card, even if one or more disclosures are already open.
        copy.querySelectorAll('details[open]').forEach(detail => {
          const summary = detail.querySelector(':scope > summary');
          if (!summary) return;
          const style = getComputedStyle(detail);
          const frame = ['borderTopWidth','borderBottomWidth','paddingTop','paddingBottom']
            .reduce((total,property) => total + (parseFloat(style[property]) || 0),0);
          const closedHeight = summary.getBoundingClientRect().height + frame;
          height -= Math.max(0,detail.getBoundingClientRect().height - closedHeight);
        });
        if (height > 0 && Math.abs(height - lastHeight) > .1) {
          photo.style.setProperty('--personal-tile-height',height + 'px');
          lastHeight = height;
        }
      };
      const schedule = () => {
        if (this.personalFrame) cancelAnimationFrame(this.personalFrame);
        this.personalFrame = requestAnimationFrame(measure);
      };
      measure();
      if ('ResizeObserver' in window) {
        this.personalObserver = new ResizeObserver(schedule);
        this.personalObserver.observe(copy);
      } else window.addEventListener('resize',schedule,{signal});
      desktop.addEventListener('change',schedule,{signal});
      copy.addEventListener('toggle',schedule,{capture:true,signal});
      if (document.fonts) document.fonts.ready.then(() => {if (!signal.aborted) schedule();});
    }
    disconnectedCallback() {
      this.personalObserver?.disconnect();
      if (this.personalFrame) cancelAnimationFrame(this.personalFrame);
      this.controller?.abort();
      this.observer?.disconnect();
      this.animations?.forEach(animation => animation.cancel());
    }
  });
}

(() => {
  if (customElements.get('fsk-care-focus')) return;

  class FskMicroFocus extends HTMLElement {
    constructor() {
      super();
      this._index = 0;
      this._elapsed = 0;
      this._running = false;
      this._userPaused = false;
      this._motionPaused = false;
      this._pointerFocus = false;
      this._frame = null;
      this._lastFrame = null;
      this._tick = this._tick.bind(this);
    }

    connectedCallback() {
      if (this._controller) return;
      this._panels = Array.from(this.querySelectorAll('[data-micro-focus-panel]'));
      this._tabs = Array.from(this.querySelectorAll('[data-micro-focus-tab]'));
      this._counter = this.querySelector('[data-micro-focus-current]');
      this._progress = this.querySelector('[data-micro-focus-progress]');
      this._toggle = this.querySelector('[data-micro-focus-toggle]');
      if (!this._panels.length || !this._toggle) return;

      this._controller = new AbortController();
      const signal = this._controller.signal;
      const requestedInterval = Number(this.dataset.interval);
      this._interval = Number.isFinite(requestedInterval) && requestedInterval >= 1000
        ? requestedInterval
        : 5000;
      this._index = Math.min(this._index, this._panels.length - 1);
      this._visible = false;
      this._mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (this._motionPreference !== this._mediaQuery.matches) {
        this._motionPaused = this._mediaQuery.matches;
      }
      this._motionPreference = this._mediaQuery.matches;

      this.addEventListener('pointerdown', () => {
        this._pointerFocus = true;
      }, { signal });

      this.addEventListener('focusin', (event) => {
        if (this._pointerFocus || this.contains(event.relatedTarget)) return;
        this._userPaused = true;
        this._syncPlayback();
      }, { signal });

      this.addEventListener('click', (event) => {
        const target = event.target instanceof Element ? event.target : null;
        const tab = target?.closest('[data-micro-focus-tab]');
        if (tab && this.contains(tab)) {
          const index = Number(tab.dataset.index);
          if (!Number.isInteger(index) || index < 0 || index >= this._panels.length) return;
          this._select(index);
          return;
        }
        if (target?.closest('[data-micro-focus-toggle]') !== this._toggle) return;
        if (this._userPaused || this._motionPaused) {
          this._userPaused = false;
          this._motionPaused = false;
        } else {
          this._userPaused = true;
        }
        this._syncPlayback();
      }, { signal });

      document.addEventListener('keydown', (event) => {
        this._pointerFocus = false;
        const tab = event.target instanceof Element
          ? event.target.closest('[data-micro-focus-tab]')
          : null;
        if (!tab || !this.contains(tab)) return;
        const position = this._tabs.indexOf(tab);
        let next;
        if (event.key === 'ArrowRight') next = (position + 1) % this._tabs.length;
        if (event.key === 'ArrowLeft') next = (position - 1 + this._tabs.length) % this._tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this._tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        this._select(Number(this._tabs[next].dataset.index));
        this._tabs[next].focus();
      }, { signal, capture: true });

      document.addEventListener('visibilitychange', () => {
        this._syncPlayback();
      }, { signal });

      this._mediaQuery.addEventListener('change', (event) => {
        this._motionPreference = event.matches;
        this._motionPaused = event.matches;
        this._syncPlayback();
      }, { signal });

      document.addEventListener('shopify:section:select', (event) => {
        if (!(event.target instanceof Element) || !event.target.contains(this)) return;
        this._userPaused = true;
        this._syncPlayback();
      }, { signal });

      if ('IntersectionObserver' in window) {
        this._observer = new IntersectionObserver((entries) => {
          const entry = entries.find((item) => item.target === this);
          if (!entry) return;
          this._visible = entry.isIntersecting && entry.intersectionRatio >= .15;
          this._syncPlayback();
        }, { threshold: [0, .15] });
        this._observer.observe(this);
      } else {
        this._visible = true;
      }

      this._render();
      this.setAttribute('data-ready', '');
      this._syncPlayback();
    }

    disconnectedCallback() {
      this._stop();
      this._controller?.abort();
      this._controller = null;
      this._observer?.disconnect();
      this._observer = null;
      this._mediaQuery = null;
      this._visible = false;
      this.dataset.playing = 'false';
    }

    _select(index) {
      if (!Number.isInteger(index) || index < 0 || index >= this._panels.length) return;
      this._userPaused = true;
      this._index = index;
      this._elapsed = 0;
      this._render();
      this._syncPlayback();
    }

    _render() {
      this._panels.forEach((panel, index) => {
        const active = index === this._index;
        panel.setAttribute('aria-hidden', String(!active));
        panel.inert = !active;
      });
      this._tabs.forEach((tab) => {
        tab.setAttribute('aria-pressed', String(Number(tab.dataset.index) === this._index));
      });
      if (this._counter) this._counter.textContent = String(this._index + 1).padStart(2, '0');
      this._updateProgress();
    }

    _updateProgress() {
      this._progress?.style.setProperty('--micro-progress', String(Math.min(1, this._elapsed / this._interval)));
    }

    _syncPlayback() {
      const paused = this._userPaused || this._motionPaused;
      const shouldRun = this.isConnected && this._visible && !document.hidden && !paused && this._panels.length > 1;
      this.dataset.paused = String(paused);
      this.dataset.playing = String(shouldRun);
      this._toggle.setAttribute('aria-label', paused
        ? this.dataset.playLabel || 'Animation abspielen'
        : this.dataset.pauseLabel || 'Animation pausieren');
      if (shouldRun && !this._running) {
        this._running = true;
        this._lastFrame = null;
        this._frame = requestAnimationFrame(this._tick);
      } else if (!shouldRun) {
        this._stop();
      }
    }

    _stop() {
      this._running = false;
      if (this._frame !== null) cancelAnimationFrame(this._frame);
      this._frame = null;
      this._lastFrame = null;
    }

    _tick(timestamp) {
      this._frame = null;
      if (!this._running) return;
      if (!this.isConnected || document.hidden || !this._visible) {
        this._syncPlayback();
        return;
      }
      if (this._lastFrame !== null) this._elapsed += timestamp - this._lastFrame;
      this._lastFrame = timestamp;
      if (this._elapsed >= this._interval) {
        const advances = Math.floor(this._elapsed / this._interval);
        this._elapsed %= this._interval;
        this._index = (this._index + advances) % this._panels.length;
        this._render();
      } else {
        this._updateProgress();
      }
      this._frame = requestAnimationFrame(this._tick);
    }
  }

  customElements.define('fsk-care-focus', FskMicroFocus);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fsk-wimpern-page"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('fsk-lash-overview')) return;

  class FskLashOverview extends HTMLElement {
    constructor() {
      super();
      this._index = 0;
      this._elapsed = 0;
      this._running = false;
      this._userPaused = false;
      this._motionPaused = false;
      this._pointerFocus = false;
      this._frame = null;
      this._lastFrame = null;
      this._tick = this._tick.bind(this);
    }

    connectedCallback() {
      if (this._controller) return;
      this._panels = Array.from(this.querySelectorAll('[data-lash-panel]'));
      this._tabs = Array.from(this.querySelectorAll('[data-lash-tab]'));
      this._counter = this.querySelector('[data-lash-current]');
      this._progress = this.querySelector('[data-lash-progress]');
      this._toggle = this.querySelector('[data-lash-toggle]');
      if (!this._panels.length || !this._toggle) return;

      this._controller = new AbortController();
      const signal = this._controller.signal;
      const requestedInterval = Number(this.dataset.interval);
      this._interval = Number.isFinite(requestedInterval) && requestedInterval >= 1000
        ? requestedInterval
        : 5000;
      this._index = Math.min(this._index, this._panels.length - 1);
      this._visible = false;
      this._mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (this._motionPreference !== this._mediaQuery.matches) {
        this._motionPaused = this._mediaQuery.matches;
      }
      this._motionPreference = this._mediaQuery.matches;

      this.addEventListener('pointerdown', () => {
        this._pointerFocus = true;
      }, { signal });

      this.addEventListener('focusin', (event) => {
        if (this._pointerFocus || this.contains(event.relatedTarget)) return;
        this._userPaused = true;
        this._syncPlayback();
      }, { signal });

      this.addEventListener('click', (event) => {
        const target = event.target instanceof Element ? event.target : null;
        const tab = target?.closest('[data-lash-tab]');
        if (tab && this.contains(tab)) {
          const index = Number(tab.dataset.index);
          if (!Number.isInteger(index) || index < 0 || index >= this._panels.length) return;
          this._select(index);
          return;
        }
        if (target?.closest('[data-lash-toggle]') !== this._toggle) return;
        if (this._userPaused || this._motionPaused) {
          this._userPaused = false;
          this._motionPaused = false;
        } else {
          this._userPaused = true;
        }
        this._syncPlayback();
      }, { signal });

      document.addEventListener('keydown', (event) => {
        this._pointerFocus = false;
        const tab = event.target instanceof Element
          ? event.target.closest('[data-lash-tab]')
          : null;
        if (!tab || !this.contains(tab)) return;
        const position = this._tabs.indexOf(tab);
        let next;
        if (event.key === 'ArrowRight') next = (position + 1) % this._tabs.length;
        if (event.key === 'ArrowLeft') next = (position - 1 + this._tabs.length) % this._tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this._tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        this._select(Number(this._tabs[next].dataset.index));
        this._tabs[next].focus();
      }, { signal, capture: true });

      document.addEventListener('visibilitychange', () => {
        this._syncPlayback();
      }, { signal });

      this._mediaQuery.addEventListener('change', (event) => {
        this._motionPreference = event.matches;
        this._motionPaused = event.matches;
        this._syncPlayback();
      }, { signal });

      document.addEventListener('shopify:section:select', (event) => {
        if (!(event.target instanceof Element) || !event.target.contains(this)) return;
        this._userPaused = true;
        this._syncPlayback();
      }, { signal });

      if ('IntersectionObserver' in window) {
        this._observer = new IntersectionObserver((entries) => {
          const entry = entries.find((item) => item.target === this);
          if (!entry) return;
          this._visible = entry.isIntersecting && entry.intersectionRatio >= .15;
          this._syncPlayback();
        }, { threshold: [0, .15] });
        this._observer.observe(this);
      } else {
        this._visible = true;
      }

      this._render();
      this.setAttribute('data-ready', '');
      this._syncPlayback();
    }

    disconnectedCallback() {
      this._stop();
      this._controller?.abort();
      this._controller = null;
      this._observer?.disconnect();
      this._observer = null;
      this._mediaQuery = null;
      this._visible = false;
      this.dataset.playing = 'false';
    }

    _select(index) {
      if (!Number.isInteger(index) || index < 0 || index >= this._panels.length) return;
      this._userPaused = true;
      this._index = index;
      this._elapsed = 0;
      this._render();
      this._syncPlayback();
    }

    _render() {
      this._panels.forEach((panel, index) => {
        const active = index === this._index;
        panel.setAttribute('aria-hidden', String(!active));
        panel.inert = !active;
      });
      this._tabs.forEach((tab) => {
        tab.setAttribute('aria-pressed', String(Number(tab.dataset.index) === this._index));
      });
      if (this._counter) this._counter.textContent = String(this._index + 1).padStart(2, '0');
      this._updateProgress();
    }

    _updateProgress() {
      this._progress?.style.setProperty('--lash-progress', String(Math.min(1, this._elapsed / this._interval)));
    }

    _syncPlayback() {
      const paused = this._userPaused || this._motionPaused;
      const shouldRun = this.isConnected && this._visible && !document.hidden && !paused && this._panels.length > 1;
      this.dataset.paused = String(paused);
      this.dataset.playing = String(shouldRun);
      this._toggle.setAttribute('aria-label', paused
        ? this.dataset.playLabel || 'Animation abspielen'
        : this.dataset.pauseLabel || 'Animation pausieren');
      if (shouldRun && !this._running) {
        this._running = true;
        this._lastFrame = null;
        this._frame = requestAnimationFrame(this._tick);
      } else if (!shouldRun) {
        this._stop();
      }
    }

    _stop() {
      this._running = false;
      if (this._frame !== null) cancelAnimationFrame(this._frame);
      this._frame = null;
      this._lastFrame = null;
    }

    _tick(timestamp) {
      this._frame = null;
      if (!this._running) return;
      if (!this.isConnected || document.hidden || !this._visible) {
        this._syncPlayback();
        return;
      }
      if (this._lastFrame !== null) this._elapsed += timestamp - this._lastFrame;
      this._lastFrame = timestamp;
      if (this._elapsed >= this._interval) {
        const advances = Math.floor(this._elapsed / this._interval);
        this._elapsed %= this._interval;
        this._index = (this._index + advances) % this._panels.length;
        this._render();
      } else {
        this._updateProgress();
      }
      this._frame = requestAnimationFrame(this._tick);
    }
  }

  customElements.define('fsk-lash-overview', FskLashOverview);
})();

  } catch(e) { console.error(e); }
})();
})();
